import React, { useEffect, useMemo, useState } from 'react'
import HeaderSection from '../../../common/headerSection'
import PageHeader from '../../../common/pageHeader'
import CustomToast from '../../../../widgets/toaster'
import CustomTable from '../../../../widgets/table'
import { useTranslation } from 'react-i18next'
import Pagination from '../../../../widgets/pagination'
import {
  columns,
  addedOperatorsColumns,
  reassignOperatorsColumns,
} from "./partials/columns";
import { helperFunctions as _h, helperFunctions } from "../../../../utils/helper";
import { userService } from '../../../../service/userService'
import moment from 'moment'
import { scheduleService } from '../../../../service/scheduleService'
import { TfiClose } from 'react-icons/tfi'
import { Button, Modal } from 'react-bootstrap'
import AlertModal from '../../../../widgets/alertModal'
import { areaService } from '../../../../service/areaServices'
import { shiftManagement } from '../../../../service/shiftManagement'
import { workflow } from '../../../../service/workflow'
import { ALLOW_CUSTOM_DATE, DEFAULT_PAGE_SIZE } from '../../../../constants/constants'
import { gradeTypes } from '../../../../service/gradeType'
import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material'
import { printWithZebraPrinter } from '../../../../utils/zebraPrinter'
import baseUrl from '../../../../service'
import CustomLoader from '../../../../widgets/loader/loader'
import { opColumns } from '../GenerateQrPlate/partials/columns'
import { userService as plateRelatedService } from '../../../../service/plateServices';
import { CiCircleRemove } from 'react-icons/ci'
import { BatchService } from '../../../../service/plateServices/discard'



const ScheduleOperatorV2 = () => {

  const { t } = useTranslation();

  const defaultFormData : any = {
    id: "",
    activity_type_id: "",
    activity_workflow_id: "",
    workflow_name: "",
    plate_count: 0,
    reason: "",
    status: "",
    created_at: "",
    updated_at: "",
    created_by: "",
    updated_by: "",
    activity_type_name: "",
    schedule_production_id: "",
    start_date_time: "",
    start_date_time_copy: "",
    end_date_time: "",
    process_id: "",
    user_master_id: "",
    production_schedule_name: "",
    product_name: "",
    production_type: "",
    user_first_name: "",
    user_last_name: "",
    operator_name: "",
    process_name: "",
    area_id: "",
    area_name: "",
    location_id: [],
    work_shift_id: "",
    location_name: "",
    work_shift_name: "",
    user_name: "",
    productionSchedule: "",
    productId: "",
    productName: "",
    areaType: "",
    gradeType: "",
    gradeTypeName: "",
    areaTypeName: "",
    productionScheduleName: "",
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD

  const date7DaysAgo = new Date();
  date7DaysAgo.setDate(date7DaysAgo.getDate() - 7);
  const formattedDate7DaysAgo = date7DaysAgo.toISOString().split("T")[0];

  const formattedTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
  const dateTime = `${formattedDate7DaysAgo} 00:00:00`;

  // end date should be 1 week ahead from currentDate
  const endDate = new Date(currentDate);
  const formattedEndDate = endDate.toISOString().split('T')[0]; // YYYY-MM-DD
  const formattedEndTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
  const endDateTime = `${formattedEndDate} 23:59:59`;

  //toaster section
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");

  // table pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [tableData, setTableData] = useState<Array<any>>([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [permission, setPermission] = useState<any>([]);
  const [keyWord, setkeyWord] = useState("");
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [addedOperators, setAddedOperators] = useState<Array<any>>([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [masterFormData, setMasterFormData] = useState(defaultFormData);
  const [modalName, setModalName] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [statusChangeAlert, setStatusChangeAlert] = useState(false);
  const [reassignOperatorSchedules, setReassignOperatorSchedules] = useState<
    Array<any>
  >([]);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  //handle error section
  interface Errors {
    activity_type_id?: string;
    workflow_id?: string;
    plate_count?: string;
    reason?: string;
    status?: string;
    schedule_production_id?: string;
    start_date_time?: string;
    end_date_time?: string;
    process_id?: string;
    user_master_id?: string;
    location_id?: string;
    work_shift_id?: string;
    added_operators?: string;
    assignUser_id?: string;
    newStartDate?: string;
    productionSchedule?: string,
    productName?: string,
    areaType?: string,
    gradeType?: string,
    lotId?: string;
    swabStick?: string,
    salineTube?: string,
    plateCount?: string;
    plateType?: string;
    mediaType?: string;
    batchId?: string;
    // plate_count?: string;
  }
  const [errors, setErrors] = useState<Errors>({});
  const defaultReassignFormData = {
    start_date_time: "",
    end_date_time: "",
    new_start_time: "",
    user_master_id: "",
    assignUser_id: "",
    reason: "",
  };
  const defaultQrFormData = {
        id: "",
        activity_type_id: "",
        batchId: "",
        lotId: "",
        nextSerialNo: "",
        plateCount: "",
        plateType: "",
        mediaType: "",
        batchName: "",
        lotCode: "",
        swabStick: "",
        salineTube: "",
        swabStickCode: "",
        salineTubeCode: "",
        lotIdWithRemainingPlates: [] as { 
          lot_id: string; 
          plate_count: number;
          lotCode: string;
          batchName: string;
        }[],
        salineTubeWithRemainingPlates: [] as { 
          id: string; 
          count: number;
          name: string;
          expiry:string
        }[],
        swabWithRemainingPlates: [] as { 
          id: string; 
          count: number;
          name: string;
          expiry: string
        }[]
    };
  const [reassignFormData, setReassignFormData] = useState(
    defaultReassignFormData
  );
  const [locationList, setLocationList] = useState<Array<any>>([]);
  const [selectedLocation, setSelectedLocation] = useState<any>([]);
  const [workShiftList, setWorkShiftList] = useState<Array<any>>([]);
  const [activityType, setActivityType] = useState<Array<any>>([]);
  const [processList, setProcessList] = useState<Array<any>>([]);
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [prodScheduleLists, setProdScheduleLists] = useState<Array<any>>([]);
  const [usersList, setUsersList] = useState<Array<any>>([]);
  const [scheduledOperatorIds, setScheduledOperatorIds] = useState<Array<any>>([]);
  const [showAddAreaAlert, setShowAddAreaAlert] = useState(false);
  const [assigSubmitAlert, setAssigSubmitAlert] = useState(false);
  const [reAssigSubmitAlert, setReAssigSubmitAlert] = useState(false);
  const [actionClearAll, setActionClearAll] = useState(false);

  const [activityTypeId, setActivityTypeId] = useState("");
  const [processId, setProcessId] = useState("");
  const [proScheduleId, setProScheduleId] = useState("")
  const [assignee, setAssignee] = useState("");
  const [status, setStatus] = useState("active");
  const [fromDate, setFromDate] = useState(dateTime);
  const [toDate, setToDate] = useState(endDateTime);
  const [areaData, setAreaData] = useState([]);
  const [selectedOperatorIds, setSelectedOperatorIds] = useState([]);
  const [workFlowList, setWorkFlowList] = useState<Array<any>>([]);
  const [areaId, setAreaId] = useState("");
  const [disableArea, setdisableArea] = useState(false);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [areaType, setTypeList] = useState<Array<any>>([]);
  const [grade, setGrade] = useState<Array<any>>([]);
  const [qrModalShow, setQrModalShow] = useState(false);
  const [selectedSlnoLen, setSelectedSlnoLen] = useState(0);
  const [qrFiles, setQrFiles] = useState<string[]>([]);
  const [zplList, setzplList] = useState<Array<any>>([]);
  const [opTableData, setOpTableData] = useState<Array<any>>([]);
  const [showGenerateQrModal, setShowGenerateQrModal] = useState(false);
  const [showGenerateQrModalTest, setShowGenerateQrModalTest] = useState(false);
  const [loader, setLoader] = useState(false);
  const [qrFormData, setQrFormData] = useState(defaultQrFormData);
  const [lotList, setLotList] = useState<Array<any>>([]);
  const [totalPlateCount, setTotalPlateCount] = useState(0);
  const [totalSwabCount, setTotalSwabCount] = useState(0);
  const [totalSalineTubeCount, setTotalSalineTubeCount] = useState(0);
  const [plateTypes, setPlateTypes] = useState([]);
  const [mediaType, setMediaType] = useState([]);
  const [batchList, setBatchList] = useState<Array<any>>([]);
  const [swabStickList, setSwabStickList] = useState<Array<any>>([]);
  const [salineTubeList, setSalineTubeList] = useState<Array<any>>([]);
  const [selectedRow, setSelectedRow] = useState(defaultFormData);
  const [selectedOpSlNo, setSelectedOpSlNo] = useState<Array<any>>([]);
  const [location, setLocation] = useState("");
  const [userId, setUserId] = useState("");
  const [filterLocationList, setFilterLocationList] = useState<Array<any>>([]);
  const [productNameId, setProductNameId] = useState("");
  const [totalPlatesRequires, setTotalPlatesRequired] = useState(0);
  const [totalSwabRequires, setTotalSwabRequired] = useState(0);
  const [totalSalineRequires, setTotalSalineRequired] = useState(0);
  const sortRemoveList=["area_name"];


  const allAreaNames = useMemo(() => locationList.map((val: any) => val.id), [locationList]);
  
  const isAllSelected = useMemo(() => {
    return masterFormData.location_id.length === allAreaNames.length;
  }, [masterFormData.location_id, allAreaNames, locationList]);
  

  // handle view click
  const handleViewClick = (id: string, viewValue: boolean) => {
    const row = tableData.filter((item) => item.slno === id);
    if (_h.arrayHasData(row) && _h.objectHasValue(row[0])) {
      //   setSelectedRow(row[0]);
      //   setShowViewModal(true);
    }
  };

  //get permission by role
  const getPermissionByRole = async (role: number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if (response.status && response.statusCode === 200) {
        setPermission(response.data.permissions);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //table filter section
  const handleFilter = (key: string, value: any) => {
    if (key === "search") {
      setkeyWord(value);
    } else if (key === "activityType") {
      setActivityTypeId(value)
      getMasterProcessList(value)
      getLocationByActivity(value, areaId)
      // } else if (key === "process") {
      //   setProcessId(value)
    } else if (key === "area") {
      setAreaId(value)
      getLocationByActivity(activityTypeId, value)
    } else if (key === "productionSchedule") {
      setProScheduleId(value)
      // } else if (key === "status") {
      //   setStatus(value)
    } else if (key === "assignee") {
      setAssignee(value)
    } else if (key === "location") {
      setLocation(value)
    } else if (key === "productName") {
      setProductNameId(value)
    } else if (key === "FromDate") {
      const formattedDate = value ? moment(value).format("YYYY-MM-DD 00:00:00") : "";
      setFromDate(formattedDate)
      setToDate("")
    } else if (key === "ToDate") {
      const formattedDate = value ? moment(value).format("YYYY-MM-DD 23:59:59") : "";
      setToDate(formattedDate)
    }
    setUseEffectRequired(true);
  };

  // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  //handle table pagination
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize);
    }
    setUseEffectRequired(true);
  };

  // get ProductionScheduleList
  const getProductionSchedules = async (areaId: string) => {
    try {
      const response = await scheduleService.getProductionSchedules(areaId);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };
  const getProductionSchedule = async (areaId: string) => {
    try {
      const response = await scheduleService.getProductionSchedule(areaId);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleLists(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleLists([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get_locations();
  const get_work_shifts = async () => {
    try {
      // const response = await scheduleService.get_work_shifts();
      const response = await shiftManagement.getShiftDropDown();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setWorkShiftList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setWorkShiftList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get Activity Type List
  const getActivityTypeList = async () => {
    try {
      const response = await scheduleService.getActivityTypeList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data
              .filter((element: any) => element.name !== "Personnel Monitoring")
              .map((element: any, index: number) => ({
                slno: index + 1,
                id: element.id,
                name: element.name,
              }));
            setActivityType(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setActivityType([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get locations List
  const getAreaList = async (areaType : any, gradeId: any) => {
    try {
      const response = await areaService.getActiveAreaList(0, 0, sort, order, "", areaType, "", gradeId);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {

              const role = element.role_master_id === "1" ?
                "Admin" : element.role_master_id === "2" ?
                  "Operator" : element.role_master_id === "3" ?
                    "Lab Operator" : null
              const statusNumber = parseInt(element.type, 10);
              const area_type = areaService.getLocationStatus(statusNumber);

              return {
                slno: index + 1,
                id: element.id,
                area_code: element.area_code,
                name: element.name,
                area_type: element.location_type_name,
                status: element.status,
                qr_image_path: element.qr_image_path,
              };
            });
            setAreaData(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaData([]);
      }
    } catch (error) {
      console.error('user response', error);
    }
  };

  // getMasterUserList()
  const getMasterUserList = async () => {
    try {
      // const response = await scheduleService.getMasterUserList();
      const response = await scheduleService.getMasterUserListWithUserCode();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.user_fullname_with_id
                  // name: (
                  //   (element?.first_name).trim() +
                  //   " " +
                  //   (element?.last_name).trim()
                  // ).trim(),
                };
              }
            );
            setUsersList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setUsersList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get the area type drop down
  const geAreaTypeList = async () => {
      try {
        const response = await areaService.geAreaDropDownList();
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              console.log(response.data, "respose--->geAreaTypeList");
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    title: element.type_name,
                    id: element.type_code,
                    status: element.status,
                  };
                }
              );
              setTypeList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        }
      } catch (error) {
        console.error("area response", error);
      }
  };

    // list grade options
  const listGrade = async () => {
    try {
      const response = await gradeTypes.listGradeOptions();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            // setTotalPages(response?.totalPages);
            // setTotalElements(response?.totalElements);
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  grade: element.grade,
                  id: element.id,
                };
              }
            );
            setGrade(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get WorkFlowList
  const getWorkFlowList = async (id: any) => {
    try {
      // const response = await scheduleService.getActivityTypeList();
      const response = await workflow.WorkflowListDrop(id)
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setWorkFlowList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setWorkFlowList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //open add area modal
  const handleAddClick = () => {
    setAddedOperators([]);
    setShowAddModal(true);
    setModalName(t("scheduleOperator.add"));
    setProcessList([]);
  };

  // handle validations
  const handleCommonFormValidation = () => {
    const errors: Errors = {};
    // if (!masterFormData.schedule_production_id) {
    //   errors.schedule_production_id = "Please select a production schedule";
    // }
    if (!masterFormData.start_date_time) {
      errors.start_date_time = t("scheduleOperator.errors.startDate");
    }
    if (masterFormData.plate_count <= 0) {
      errors.plate_count = t("scheduleOperator.errors.plateQuantity");
    }
    // if (!masterFormData.end_date_time) {
    //   errors.end_date_time = "Please select an end date time";
    // }
    if (!masterFormData.activity_type_id) {
      errors.activity_type_id = t("scheduleOperator.errors.activityType");
    }
    if (!masterFormData.activity_workflow_id) {
      errors.workflow_id = t("scheduleOperator.errors.workFlow");
    }
    // Make production schedule optional for Plate Sampling activity type
    if (!masterFormData.productionSchedule && masterFormData.activity_type_name !== "Plate Sampling") {
      errors.productionSchedule = t("scheduleOperator.errors.productionSchedule");
    }
    // if (!masterFormData.product_name) {
    //   errors.productName = t("scheduleOperator.errors.productName");
    // }
    if (!disableArea) {
      if (!masterFormData.areaType) {
        errors.areaType = t("scheduleOperator.errors.areaType");
      }
      if (!masterFormData.gradeType) {
        errors.gradeType = t("scheduleOperator.errors.gradeType");
      }
      if (masterFormData.location_id <= 0 ) {
        errors.location_id = t("scheduleOperator.errors.location");
      }
    }
    // if (!masterFormData.process_id) {
    //   errors.process_id = "Please select a process";
    // }
    // if (masterFormData.area_id && !masterFormData.location_id) {
    //   errors.location_id = t("scheduleOperator.errors.location");
    // }
    // if (!masterFormData.work_shift_id) {
    //   errors.work_shift_id = "Please select a work shift";
    // }
    // if (!masterFormData.user_master_id) {
    //   errors.user_master_id = "Please select an operator";
    // }
    if (
      _h.isNotEmpty(masterFormData.start_date_time)
    ) {
      //   let fromEpoch = new Date(masterFormData.start_date_time).valueOf();
      //   let toEpoch = new Date(masterFormData.end_date_time).valueOf();
      //   if (fromEpoch >= toEpoch) {
      //     errors.start_date_time = "Start date should be less than End date";
      //     errors.end_date_time = "End date should be greater than Start date";
      //   }
    }
    if (masterFormData.id && !masterFormData.reason) {
      errors.reason = t("scheduleOperator.errors.reason");
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    }
    setErrors({});
    return true;
  };

  // handle status change
  const handleStatusChange = (id: string, status: string) => {
    setSelectedId(id);
    if (status === "active") {
      setUpdatedStatus("inactive");
    } else {
      setUpdatedStatus("active");
    }
    setStatusChangeAlert(true);
  };

  //filter selected id based on the row selected while editing
  const handleEditClick = (id: string) => {
    const row = tableData.filter((item) => item.slno === id);
    if (_h.arrayHasData(row) && _h.objectHasValue(row[0])) {
      setMasterFormData(row[0]);
      setShowAddModal(true);
      setModalName(t("scheduleOperator.editOperatorSchedules"));
    }
  };

  // handle click re assign operator
  const handleReassignOperator = () => {
    setReassignOperatorSchedules([]);
    setShowReassignModal(true);
    setModalName(t("scheduleOperator.reassign_operator"));
  };

  // get table data
  const getOperatorScheduleList = async () => {
    try {
      const response = await scheduleService.getOperatorScheduleList(
        page,
        pageSize,
        sort,
        order,
        keyWord,
        proScheduleId,
        activityTypeId,
        processId,
        status,
        assignee,
        fromDate,
        toDate,
        areaId,
        location,
        productNameId
      );
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            // Filter out null user_master_id when an assignee is selected
          const filteredData = assignee 
            ? response.data.filter((element: any) => element.user_master_id === assignee)
            : response.data;
            setTotalPages(response?.totalPages);
            setTotalElements(response?.totalElements);
            let rowData: any = filteredData.map((element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  status: element.status,
                  plateSerialNo: element.serial_number,
                  activity_type_id: element.activity_type_id,
                  created_at: element?.created_at
                    ? moment(element?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  updated_at: element?.updated_at
                    ? moment(element?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                      "DD-MM-YYYY - HH:mm:ss"
                    )
                    : "-",
                  schedule_production_id: element?.schedule_production_id,
                  start_date_time: element?.start_date_time
                    ? moment(
                      element?.start_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY")
                    : "-",
                  end_date_time: element?.end_date_time
                    ? moment(
                      element?.end_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY - HH:mm:ss")
                    : "-",
                  process_id: element?.process_id,
                  user_master_id: element?.user_master_id,
                  created_by: element?.created_by,
                  updated_by: element?.updated_by,
                  production_schedule_name: element?.production_schedule_name,
                  product_name: element?.product_name,
                  production_type: element?.production_type,
                  user_first_name: element?.user_first_name,
                  user_last_name: element?.user_last_name,
                  // operator_name: (
                  //     (element?.user_first_name).trim() +
                  //     " " +
                  //     (element?.user_last_name).trim()
                  // ).trim(),
                  operator_name: `${element?.user_first_name || ""} ${element?.user_last_name || ""}`,
                  process_name: element?.process_name,
                  activity_type_name: element?.activity_type_name,
                  area_name: element?.area_name,
                  location_name: element?.location_name,
                  location_id: element?.location_id,
                  work_shift_name: element?.work_shift_name,
                  prn_value: element?.prn_value,
                  activity_workflow_id: element?.activity_workflow_id
                };
              }
            );
            const filteredRowData = rowData.filter((data: any) => data.activity_type_name !== "Personnel Monitoring");
            setTableData(filteredRowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //clear modal on close
  const handleFormClose = () => {
    setShowAddModal(false);
    setShowAssignModal(false);
    setErrors({});
    setMasterFormData(defaultFormData);
    setAddedOperators([]);
    setShowReassignModal(false);
    setReassignFormData(defaultReassignFormData);
    setReassignOperatorSchedules([]);
    setProcessList([]);
    setWorkFlowList([]);
    getProductionSchedules("");
    getProductionSchedule("");
  };

  // get_locations();
  const get_locations = async (filters: any, areaId: any, gradeId?: any) => {
    try {
      // const response = await scheduleService.get_locations(filters);
      const response = await areaService.getLocationByActivity(filters, gradeId, "", areaId);
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setLocationList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setLocationList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get location by Activity 
  const getLocationByActivity = async (id: any, areaId: any) => {
      try {
          const response = await areaService.getLocationByActivity(id, '', '', areaId);
          if (response.status && response.statusCode === 200) {
              try {
                  if (Array.isArray(response.data) && response.data?.length > 0) {
                      let rowData: any = response.data.map(
                          (element: any, index: number) => {
                              return {
                                  slno: index + 1,
                                  id: element.id,
                                  name: element.name,
                              };
                          }
                      );
                      setFilterLocationList(rowData);
                  }
              } catch (error) {
                  console.log(error);
              }
          } else {
              setFilterLocationList([]);
          }
      } catch (error) {
          setFilterLocationList([]);
          console.error("user response", error);
      }
  };

  // get MasterProcessList
  const getMasterProcessList = async (activity_type_id: string) => {
    let rowData: any = [];
    try {
      if (
        _h.isNotEmpty(masterFormData.activity_type_id) ||
        _h.isNotEmpty(activity_type_id)
      ) {
        const response = await scheduleService.get_process_by_activity(
          _h.isNotEmpty(activity_type_id)
            ? activity_type_id
            : masterFormData.activity_type_id
        );
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              rowData = response.data.map((element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                };
              });
              setProcessList(rowData);
            }
          } catch (error) {
            console.log(error);
            setProcessList([]);
          }
        } else {
          setProcessList([]);
        }
      } else {
        setProcessList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
    return rowData;
  };

  //handle onchange input fields
  const handleAddFieldOnChange = async (e: any) => {
    let { name, value } = e.target;
    if (e.target.type === 'number' && value !== '') {
      value = Number(value);
    }
    // if (name == "schedule_production_id") {
    //   let selectedProd = prodScheduleList.filter((prod) => {
    //     return prod.id == value;
    //   });
    //   console.log("handleFieldOnChange=>selectedProd", selectedProd);
    //   if (_h.arrayHasData(selectedProd) && _h.objectHasValue(selectedProd[0])) {
    //     let activityProcess: any = await getMasterProcessList(
    //       selectedProd[0]?.activity_type_id
    //     );
    //     console.log("handleFieldOnChange=>activityProcess", activityProcess);
    //     setProcessList(activityProcess);
    //     setMasterFormData((prevFormData: any) => ({
    //       ...prevFormData,
    //       activity_type_id: selectedProd[0]?.activity_type_id,
    //     }));
    //   }
    // }
    if (
      name == "schedule_production_id" &&
      _h.isNotEmpty(masterFormData?.process_id)
    ) {
      // get_locations({
      //     process_id: masterFormData?.process_id,
      //     production_id: value,
      // });
    }

    if (name == "product_name") {
        let productName = productList.filter((val) => value == val?.name);
        if (_h.arrayHasData(productName) && _h.objectHasValue(productName[0])) {
          setMasterFormData((prevFormData: any) => ({
            ...prevFormData,
            productId: productName[0]?.id,
            productName: productName[0]?.name
          }));
        } else {
          setMasterFormData((prevFormData: any) => ({
            ...prevFormData,
            productId: "",
            productName: ""
          }));
        }
      }

    if (name == "activity_type_id") {
      if (_h.isNotEmpty(value)) {
        let selectedName = activityType.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          location_id: [],
          activity_type_name: selectedName[0]?.name,
        }));
        let activityProcess: any = await getMasterProcessList(value);
        setProcessList(activityProcess);
        get_locations(value, masterFormData.area_id)
        getWorkFlowList(value)  

        if (value === "5" || value === "6"){
          setdisableArea(true)
          setMasterFormData((prevFormData: any) => ({
            ...prevFormData,
            area_id: "",
            location_id: [],
            area_name: "",
            location_name: ""
          }));
        } else {
          setdisableArea(false)
        }
      }
    }
    if (name == "activity_workflow_id") {
      let selectedName = workFlowList.filter((row) => {
        return row.id == value;
      });
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        workflow_name: selectedName[0]?.name,
      }));
    }

    if (name == "process_id") {
      let selectedName = processList.filter((row) => {
        return row.id == value;
      });
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        process_name: selectedName[0]?.name,
      }));
      // get_locations({
      //     process_id: value,
      //     production_id: masterFormData?.schedule_production_id,
      // });
    }

    if (name === "area_id") {
      // areaListing(value)
      if (_h.isNotEmpty(value)) {
        let selectedName: any = areaData?.filter((row: any) => {
          return row.id == value;
        });
        // let selectedNames: any[] = areaData?.filter((row: any) => {
        //   return value.includes(row.id); // check if row.id exists in the value array
        // });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          area_name: selectedName[0]?.name,
        }));

        // setMasterFormData((prevFormData: any) => ({
        //   ...prevFormData,
        //   area_name: selectedNames.map(item => item.name).join(', '), // combine multiple names into a string
        // }));
        get_locations(masterFormData.activity_type_id, value, masterFormData.gradeType)
        getProductionSchedules(value);
        getProductionSchedule(value);
      }
    }

    if (name == "location_id") {
      if (_h.isNotEmpty(value)) {
        // let selectedName = locationList.filter((row) => {
        //   return row.id == value;
        // });

        let selectedNames: any[] = locationList?.filter((row: any) => {
          return value.includes(row.id); // check if row.id exists in the value array
        });

        // setMasterFormData((prevFormData: any) => ({
        //   ...prevFormData,
        //   location_name: selectedName[0]?.name,
        // }));

        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          location_name: selectedNames.map(item => item.name).join(', '), // combine multiple names into a string
        }));

      }
    }
    if (name == "work_shift_id") {
      if (_h.isNotEmpty(value)) {
        let selectedName = workShiftList.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          work_shift_name: selectedName[0]?.name,
        }));
      }
    }
    if (name == "areaType") {
        let selectedName = areaType.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          areaTypeName: selectedName[0]?.title,
          production_schedule_name: "",
          productionScheduleName: "",
          schedule_production_id: "",
          productionSchedule: ""
        }));
        getAreaList(value, masterFormData.gradeType)
        // getProductionSchedules("");
        getProductionSchedule("");
    }
    if (name == "gradeType") {
        let selectedName = grade.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          gradeTypeName: selectedName[0]?.grade,
          production_schedule_name: "",
          productionScheduleName: "",
          schedule_production_id: "",
          productionSchedule: ""
        }));
        getAreaList(masterFormData.areaType, value)
        if (masterFormData.activity_type_id) {
      get_locations(masterFormData.activity_type_id, masterFormData.area_id, value);
    }
        //getProductionSchedules("");
        getProductionSchedule("");
    }
     if (name == "productionSchedule") {
      if (_h.isNotEmpty(value)) {
        let selectedName = prodScheduleList.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          production_schedule_name: selectedName[0]?.production_schedule_name,
          productionScheduleName: selectedName[0]?.production_schedule_name,
          schedule_production_id: selectedName[0]?.id
        }));
      }
    }

    if (name == "user_master_id") {
      if (_h.isNotEmpty(value)) {
        let selectedName = usersList.filter((row) => {
          return row.id == value;
        });
        setMasterFormData((prevFormData: any) => ({
          ...prevFormData,
          user_name: selectedName[0]?.name,
        }));
      }
    }

    if (name == "start_date_time" && _h.isNotEmpty(value)) {
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        start_date_time: moment(value, "YYYY-MM-DD").format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        start_date_time_copy: moment(value, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        ),
      }));
    } else if (name == "end_date_time" && _h.isNotEmpty(value)) {
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        end_date_time: moment(value, "YYYY-MM-DDTHH:mm").format(
          "DD-MM-YYYY - HH:mm:ss"
        ),
      }));
    } else {
      setMasterFormData((prevFormData: any) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

  };

  //handle area validation starts here
  const handleFormValidation = () => {
    if (masterFormData.id) {
      if (!handleCommonFormValidation()) {
        return;
      }
    }

    // const errors: Errors = {};
    // if (!masterFormData.activity_type_id) {
    //   errors.activity_type_id = "Please select an activity type";
    // }
    // if (!masterFormData.schedule_production_id) {
    // errors.schedule_production_id = "Please select an activity type";
    // }
    // if (!masterFormData.start_date_time) {
    // errors.start_date_time = "Please select an activity type";
    // }
    // if (!masterFormData.end_date_time) {
    // errors.end_date_time = "Please select an activity type";
    // }
    // if (!masterFormData.process_id) {
    //   errors.process_id = "Please select an activity type";
    // }
    // if (!masterFormData.user_master_id) {
    //   errors.user_master_id = "Please select an activity type";
    // }
    // if (
    // _h.isNotEmpty(masterFormData.start_date_time) &&
    // _h.isNotEmpty(masterFormData.end_date_time))
    // ) {
    // let fromEpoch = new Date(masterFormData.start_date_time).valueOf();
    // let toEpoch = new Date(masterFormData.end_date_time).valueOf();
    // if (fromEpoch >= toEpoch) {
    //     errors.start_date_time = "Start date should be less than End date";
    //     errors.end_date_time = "End date should be greater than Start date";
    // }
    // }

    if (addedOperators.length == 0) {
      // errors.reason = "Please enter reason for edit";
      // added_operators
      setToastType("error");
      setToastMessage(t("scheduleOperator.errors.oneOperator"));
      setShowToast(true);
      setShowAddAreaAlert(false);
      return;
    }

    // if (Object.keys(errors).length > 0) {
    //   setErrors(errors);
    //   return;
    // }
    setShowAddAreaAlert(true);
    setErrors({});
  };

  // handle submitt re assign operator
  const handleReAssignFormSubmit = async () => {
    const formattedStartDate = reassignFormData?.start_date_time ? moment(reassignFormData.start_date_time, "DD-MM-YYYY - HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : "";
    const formattedEndDate = reassignFormData?.end_date_time ? moment(reassignFormData.end_date_time, "DD-MM-YYYY - HH:mm:ss").format("YYYY-MM-DD 23:59:59") : "";
    const formattedNewDate = reassignFormData?.new_start_time ? moment(reassignFormData.new_start_time, "DD-MM-YYYY - HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : "";

    const dataToSend = {
      start_date_time: formattedStartDate,
      end_date_time: formattedEndDate,
      new_start_time: formattedNewDate,
      user_master_id: reassignFormData.user_master_id,
      assignUser_id: reassignFormData.assignUser_id,
      operator_ids: selectedOperatorIds,
      interface_name: "Assign Operator - Reassign Operator",
      reason: reassignFormData.reason,
    }
    try {
      const response = await scheduleService.reassignScheduleOperator(dataToSend);
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage(response.message);
        getOperatorScheduleList();
        handleFormClose();
        setReAssigSubmitAlert(false);
      } else {
        setToastType("error");
        setToastMessage(response.message);
      }
      setShowToast(true);
    } catch (error) {
      console.error(error);
    }

    return true;
  };

  // assign validation check
  const assignFieldOnSubmit = () => {
    const errors: Errors = {};
    if (!masterFormData?.work_shift_id) {
      errors.work_shift_id = t("scheduleOperator.errors.workshift");
    }
    if (!masterFormData.user_master_id) {
      errors.user_master_id = t("scheduleOperator.errors.user");
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setAssigSubmitAlert(true)
    setErrors({});
  }

  // re assign validation check
  const reAssignFieldOnSubmit = () => {
    const errors: Errors = {};
    if (!reassignFormData.start_date_time) {
      errors.start_date_time = t("scheduleOperator.errors.startDate");
    }
    if (!reassignFormData.end_date_time) {
      errors.end_date_time = t("scheduleOperator.errors.endDate");
    }
    if (!reassignFormData.user_master_id) {
      errors.user_master_id = t("scheduleOperator.errors.operator");
    }
    if (!reassignFormData.assignUser_id) {
      errors.assignUser_id = t("scheduleOperator.errors.reassignOperator");
    }
    if (!reassignFormData.reason) {
      errors.reason = t("exceptionHandling.errors.reason");
    }
    if (reassignFormData.user_master_id && reassignFormData.user_master_id == reassignFormData.assignUser_id) {
      errors.assignUser_id = t("scheduleOperator.errors.differentOperator");
    }
    if (
      _h.isNotEmpty(reassignFormData.start_date_time) &&
      _h.isNotEmpty(reassignFormData.end_date_time)
    ) {
      let fromEpoch = new Date(reassignFormData.start_date_time).valueOf();
      let toEpoch = new Date(reassignFormData.end_date_time).valueOf();
      if (fromEpoch >= toEpoch) {
        errors.start_date_time = t("scheduleOperator.errors.lessStartDate");
        errors.end_date_time = t("scheduleOperator.errors.greaterStartDate");
      }
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    }
    setErrors({});
    setReAssigSubmitAlert(true)
  }

  // update selected operator table data
  const updateSelectedOperatorTableData = () => {
    if (!handleCommonFormValidation()) {
      return;
    }
    // addedOperators.unshift(masterFormData);
    // let rowData: any = addedOperators.map((element: any, index: number) => {
    //   return {
    //     ...element,
    //     slno: index + 1,
    //   };
    // });

    console.log(masterFormData, "masterFormData")

    const locationNames = masterFormData.location_name.split(',').map((name: any) => name.trim());

    const { location_id, location_name, ...baseData } = masterFormData;

    let addedOperators2: any[] = [];
    const locationIds = Array.isArray(location_id) ? location_id : [];

    if (locationIds.length > 0 && locationNames.length > 0) {
      // Map per location
      addedOperators2 = locationIds.map((id: string, index: number) => ({
        ...baseData,
        location_id: id,
        location_name: locationNames[index] || '' // fallback to empty string
      }));
    } else {
      // Fallback: use just baseData
      addedOperators2 = [{
        ...baseData,
        location_id: '',
        location_name: ''
      }];
    }

    setAddedOperators((prevOperators: any[]) => {
      const updatedRowData = addedOperators2.map((element: any, index: number) => ({
        ...element,
        slno: prevOperators.length + index + 1, // Continue slno from existing data
      }));

      return [...prevOperators, ...updatedRowData];
    });

    // Add serial numbers
    // let rowData = addedOperators2.map((element: any, index: any) => ({
    //   ...element,
    //   slno: index + 1
    // }));


    // setAddedOperators(rowData);
    setMasterFormData((prevFormData: any) => ({
      ...prevFormData,
      activity_type_id: "",
      process_id: "",
      area_id: "",
      location_id: [],
      area_name: "",
      location_name: "",
      work_shift_id: "",
      user_master_id: "",
      start_date_time: "",
      activity_workflow_id: "",
      workflow_name: "",
      plate_count: 0,
      productionSchedule: "",
      productId: "",
      productName: "",
      product_name: "",
      areaType: "",
      gradeType: "",
      gradeTypeName: "",
      areaTypeName: "",
      productionScheduleName: "",
      production_schedule_name: "",
      schedule_production_id: ""
    }));
    setProcessList([])
    setLocationList([])
    getProductionSchedules("");
    getProductionSchedule("");
  };

  //handle onchange input fields
  const handleReassignFieldOnChange = async (e: any) => {
    const { name, value } = e.target;
    let tempReassignFormData: any = reassignFormData;

    if (
      ["start_date_time", "end_date_time", "new_start_time"].includes(name) &&
      _h.isNotEmpty(value)
    ) {
      tempReassignFormData[name] = moment(value, "YYYY-MM-DD").format(
        "DD-MM-YYYY - HH:mm:ss"
      );
    } else {
      tempReassignFormData[name] = value;
    }
    if (
      ["user_master_id", "start_date_time", "end_date_time"].includes(name) &&
      _h.isNotEmpty(tempReassignFormData?.user_master_id) &&
      _h.isNotEmpty(tempReassignFormData?.start_date_time) &&
      _h.isNotEmpty(tempReassignFormData?.end_date_time)
    ) {
      setReassignOperatorSchedules([]);
      const response = await scheduleService.getOperatorSchedules({
        sort: "id",
        order: "desc",
        user_master_id: tempReassignFormData?.user_master_id,
        start_date_time: moment(
          tempReassignFormData.start_date_time,
          "DD-MM-YYYY - HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss"),
        end_date_time: moment(
          tempReassignFormData.end_date_time,
          "DD-MM-YYYY - HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss"),
      });
      console.log("1110")
      if (response.status && response.statusCode === 200) {
        console.log("1111")
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            console.log("1112")
            // let rowData: any = response.data.map(
            //   (element: any, index: number) => {
            const rowData = response.data
              .filter((element: any) =>  element.user_master_id !== null && 
                (element.plate_status === "1" || element.plate_status === null)
                     )
              .map((element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  start_date_time: element?.start_date_time
                    ? moment(
                      element?.start_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY")
                    : "-",
                  end_date_time: element?.end_date_time
                    ? moment(
                      element?.end_date_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("DD-MM-YYYY")
                    : "-",
                  production_schedule_name: element?.production_schedule_name,
                  product_name: element?.product_name,
                  production_type: element?.production_type,
                  user_first_name: element?.user_first_name,
                  user_last_name: element?.user_last_name,
                  // operator_name: (
                  //   (element?.user_first_name).trim() +
                  //   " " +
                  //   (element?.user_last_name).trim()
                  // ).trim(),
                  process_name: element?.process_name,
                  activity_type_name: element?.activity_type_name,
                  area_name: element?.area_name,
                  location_name: element?.location_name,
                  work_shift_name: element?.work_shift_name,
                  user_master_id: element.user_master_id,
                  plate_status:element.plate_status
                };
              });
            console.log(rowData, "rowData")
            setReassignOperatorSchedules(rowData);
          }
        } catch (error) {
          console.log(error);
          setReassignOperatorSchedules([]);
        }
      }
    }
    // setReassignFormData(tempReassignFormData);
    const startDate = moment(tempReassignFormData["start_date_time"], 'DD-MM-YYYY - HH:mm:ss');
    const endDate = moment(tempReassignFormData["end_date_time"], 'DD-MM-YYYY - HH:mm:ss');
  
    if (tempReassignFormData["start_date_time"] && tempReassignFormData["end_date_time"]) {
      if (startDate > endDate) {
        tempReassignFormData["end_date_time"] = "";
      }
    }
    setReassignFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: tempReassignFormData[name],
    }));
  };

  // handle assign operator clcik
  const handleAssignOperatorClick = (slno: string[]) => {
    const filteredPlateDetails = tableData.filter((item: any) => slno.includes(item.slno));
    const scheduledOperatorIds: any = filteredPlateDetails.map((item: any) => item.id)

    const updatedPlateDetails = tableData
      .filter((item: any) => slno.includes(item.slno))
      .map((item: any, index: number) => ({
        ...item,
        slno: index + 1 // Update slno with the new value
      }));
    const anyHasAssigne = updatedPlateDetails.some(item => item.operator_name && item.operator_name !== " ");

    if (anyHasAssigne) {
      setToastMessage(t("scheduleOperator.operatorAlreadyAssigned"));
      setToastType("error")
      setShowToast(true)
    } else {
      if (slno.length > 0) {
        setScheduledOperatorIds(scheduledOperatorIds)
      } else {
        setScheduledOperatorIds([])
      }
      setShowAssignModal(true)
      setModalName(t("scheduleOperator.tableHead"))
    }
  }

  // reassign button click
  const handleReassignActionClick = (slno: string[]) => {
    const filteredPlateDetailsIds: any = reassignOperatorSchedules
      .filter((item: any) => slno.includes(item.slno))
      .map((item: any) => Number(item.id));
    setSelectedOperatorIds(filteredPlateDetailsIds)
  }

  // handle assign form submit 
  const handleAssignFormSubmit = async () => {
  setLoader(true)

    const dataToSend = scheduledOperatorIds?.map(id => ({
      "schedule_operator_id": id,
      "user_master_id": masterFormData.user_master_id,
      "interface_name": modalName
    }));

    try {
      const response = await scheduleService.assignOperator(
        dataToSend
      );
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage(response.message);
        getOperatorScheduleList();
        setAssigSubmitAlert(false)
        setActionClearAll(true)
        handleFormClose();
      } else {
        setToastType("error");
        setToastMessage(response.message);
      }
      setShowAddAreaAlert(false);
      setShowToast(true);
    } catch (error) {
      console.error(error);
    }finally{
      setLoader(false)
    }
  }

  //handle add area submit api call
  const handleFormSubmit = async () => {
    setLoader(true)
    // const dataToSend = {
    //   id: masterFormData.id,
    //   activity_type_id: masterFormData.activity_type_id,
    //   interface_name: "Schedule Operator",
    //   reason: masterFormData.reason,
    //   schedule_production_id: masterFormData.schedule_production_id,
    //   start_date_time: _h.isNotEmpty(masterFormData.start_date_time)
    //     ? moment(
    //         masterFormData.start_date_time,
    //         "DD-MM-YYYY - HH:mm:ss"
    //       ).format("YYYY-MM-DD HH:mm:ss")
    //     : "",
    //   end_date_time: _h.isNotEmpty(masterFormData.end_date_time)
    //     ? moment(masterFormData.end_date_time, "DD-MM-YYYY - HH:mm:ss").format(
    //         "YYYY-MM-DD HH:mm:ss"
    //       )
    //     : "",
    //   process_id: masterFormData.process_id,
    //   user_master_id: masterFormData.user_master_id,
    // };
    let dataToSend: any = [];
    Object.values(addedOperators).forEach((val: any) => {
      // val["start_date_time"] = _h.isNotEmpty(masterFormData.start_date_time)
      //     ? moment(
      //         masterFormData.start_date_time,
      //         "DD-MM-YYYY - HH:mm:ss"
      //     ).format("YYYY-MM-DD HH:mm:ss")
      //     : "";
      // val["end_date_time"] = _h.isNotEmpty(masterFormData.end_date_time)
      //     ? moment(masterFormData.end_date_time, "DD-MM-YYYY - HH:mm:ss").format(
      //         "YYYY-MM-DD HH:mm:ss"
      //     )
      //     : "";
      val["interface_name"] = "Assign Operator - Create Task";
      dataToSend.push(val);
    });

    try {
      const response = await scheduleService.createScheduleOperatorBulk(
        dataToSend
      );
      if (response.status && response.statusCode === 200) {
        setToastType("success");
        setToastMessage(response.message);
        getOperatorScheduleList();
        handleFormClose();
        setLoader(false)
      } else {
        setToastType("error");
        setToastMessage(response.message);
      }
      setShowAddAreaAlert(false);
      setShowToast(true);
    } catch (error) {
      console.error(error);
    }finally{
      setLoader(false)
    }
  };

  //api call to get the plate types 
  const getPlateTypeList = async (activityWorkFlowId : string) => {
  try {
      const response = await plateRelatedService.listAllPlateTypes(activityWorkFlowId);
      if (response.status && response.statusCode === 200) {
      setPlateTypes(response.data)
      }
  } catch (error) {
      console.error('user response', error);
  }
  }
  
  // api to get media type
  const getMediaType = async () => {
  try {
      const response = await plateRelatedService.getMediaType();
      if (response.status && response.statusCode === 200) {
      setMediaType(response.data)
      }
  } catch (error) {
      console.error('user response', error);
  }
  }

  //api call to get batch list
  const getBatchList = async (plateType: string) => {
      try {
          const response = await scheduleService.getBatchListByAvailability(plateType);
          if (response.status && response.statusCode === 200) {
              try {
                  if (Array.isArray(response.data) && response.data?.length > 0) {
                      let rowData: any = response.data.map(
                          (element: any, index: number) => {
                              return {
                                  id: element.id,
                                  name: element.batch_no,
                              };
                          }
                      );
                      setBatchList(rowData);
                  }
              } catch (error) {
                  console.log(error);
              }
          } else {
              setBatchList([]);
          }
      } catch (error) {
          console.error("user response", error);
      }
  };

   //api call to get swab stick list
  const getSwabStickList = async () => {
      try {
          const response = await BatchService.getAvailableSwabStickBatchFilter();
          if (response.status && response.statusCode === 200) {
              try {
                  if (Array.isArray(response.data) && response.data?.length > 0) {
                      let rowData: any = response.data.map(
                          (element: any, index: number) => {
                              return {
                                  id: element.id,
                                  name: element.batch_no,
                                  remaining_plates_count: element?.available_swab_count,
                                  expiry_date: element.expiry_date
                              };
                          }
                      );
                      setSwabStickList(rowData);
                  }
              } catch (error) {
                  console.log(error);
              }
          } else {
              setSwabStickList([]);
          }
      } catch (error) {
          console.error("user response", error);
      }
  };

   //api call to get saline tube list
  const getSalineTubeList = async () => {
      try {
          const response = await BatchService.getAvailableTestTubeBatchFilter();
          if (response.status && response.statusCode === 200) {
              try {
                  if (Array.isArray(response.data) && response.data?.length > 0) {
                      let rowData: any = response.data.map(
                          (element: any, index: number) => {
                            const capacity = Number(element?.capacity ?? 0);
                            const usedCapacity = Number(element?.used_capacity ?? 0);
                              return {
                                  id: element.id,
                                  name: element.batch_no,
                                  remaining_plates_count: element.available_test_tube_count,
                                  expiry_date: element.expiry_date
                                  // remaining_plates_count: Math.max(0, capacity - usedCapacity)
                              };
                          }
                      );
                      setSalineTubeList(rowData);
                  }
              } catch (error) {
                  console.log(error);
              }
          } else {
              setSalineTubeList([]);
          }
      } catch (error) {
          console.error("user response", error);
      }
  };

  // handle download QR button
  const handleDownloadQR = async (slno: string[]) => {
  const filteredPlateDetails = tableData.filter((item: any) => slno.includes(item.slno));
  const scheduledOperatorIds: any = filteredPlateDetails.map((item: any) => item.id).join(',');
  const allHavePlateSerialNo = filteredPlateDetails.every((item: any) => item.plateSerialNo && item.plateSerialNo !== "");
  const prnList = filteredPlateDetails.map((item: any) => item.prn_value);

      // Now you can use the `allHavePlateSerialNo` variable as needed
  if (allHavePlateSerialNo) {
    try {
      const response = await scheduleService.getGeneratedProductionPlateQrV2({
        schedule_production_id: scheduledOperatorIds,
      });
      if (response.status && response.statusCode === 200) {
        if (Array.isArray(response.data) && response.data?.length > 0) {
          // Map the API response to match the expected format
          const mappedData = response.data.map((item: any) => ({
            ...item,
            assigned_activity_name: item.activity_type_name,
            area_name: item.area_name,
            assigned_operator_name: item.assigned_operator_name,
            fingerdabbing_operator_name: item.fingerdabbing_operator_name,
            finger_dab_option_name: item.finger_dab_option_name || '',
            qr_file_path: item.qr_file_path,
          }));

          setSelectedSlnoLen(mappedData.length);
          setQrFiles(mappedData);
          setQrModalShow(true);
          setzplList(prnList);
        } else {
          setToastType("error");
          setToastMessage("No plates are generated yet.");
          setShowToast(true);
        }
      } else {
        setToastType("error");
        setToastMessage(response.message || "Failed to fetch QR codes");
        setShowToast(true);
      }
    } catch (error) {
      console.error("Error fetching QR codes:", error);
      setToastType("error");
      setToastMessage("An error occurred while fetching QR codes");
      setShowToast(true);
    }
  } else {
    setToastMessage("Some items are missing plate serial no");
    setToastType("error");
    setShowToast(true);
  }
}

  // handle close modal
  const handleCloseQrModal = () => {
      setQrModalShow(false);
  }

  const createGrid = () => {
    {return qrFiles.map((cellIndex: any, index: number) => {
          // Check if the activity is "Personnel Monitoring"
          const isPersonnelMonitoring = cellIndex?.assigned_activity_name === "Personnel Monitoring";
  
          if (isPersonnelMonitoring) {
            // Personnel Monitoring layout
            return (
              <div
                key={index}
                className="page"
                style={{
                  width: "210mm",
                  height: "297mm",
                  pageBreakAfter: "always",
                  padding: "10mm",
                  boxSizing: "border-box",
                  display: "grid",
                  gridTemplateColumns: "auto 1fr auto",
                  gridTemplateRows: "auto 1fr auto",
                  alignItems: "center",
                  justifyItems: "center",
                  marginTop: "10mm"
                }}
              >
                {/* Top Text */}
                <div
                  style={{
                    gridColumn: "1 / 4",
                    fontSize: "15mm",
                    textAlign: "center",
                    marginBottom: "2mm",
                    marginTop: "10mm"
                  }}
                >
                  <p style={{ margin: "1mm 0" }}>{cellIndex?.assigned_activity_name}</p>
                </div>
      
                {/* Left Text (Vertical) */}
                <div
                  style={{
                    gridRow: "2",
                    writingMode: "vertical-rl",
                    transform: "rotate(180deg)",
                    fontSize: "15mm",
                    textAlign: "center",
                  }}
                >
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.area_name}</p>
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.assigned_operator_name}</p>
                </div>
      
                {/* QR Image in the center */}
                <img
                src={baseUrl + "/" + cellIndex?.qr_file_path}
                alt={`Image ${cellIndex?.production_schedule_name}`}
                style={{
                gridRow: "2",
                gridColumn: "2",
                width: "220mm",
                height: "220mm",
                objectFit: "contain",
                }}
            />
      
                {/* Right Text (Vertical) */}
                <div
                  style={{
                    gridRow: "2",
                    writingMode: "vertical-rl",
                    fontSize: "15mm",
                    textAlign: "center",
                  }}
                >
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.serial_number}</p>
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.fingerdabbing_operator_name}</p>
                </div>
      
                {/* Bottom Text */}
                <div
                  style={{
                    gridColumn: "1 / 4",
                    fontSize: "15mm",
                    textAlign: "center",
                    marginTop: "2mm",
                  }}
                >
                  <p style={{ margin: "1mm 0" }}>{cellIndex?.finger_dab_option_name}</p>
                  <p style={{ margin: "1mm 0" }}>{moment(cellIndex?.qr_generated_datetime).format("DD-MM-YYYY - HH:mm:ss")}</p>
                </div>
              </div>
            );
          } else {
    return (
        <div>
            <div
            key={index}
            className="page"
            style={{
                width: "210mm",
                height: "297mm",
                pageBreakAfter: "always",
                padding: "10mm",
                boxSizing: "border-box",
                display: "grid",
                gridTemplateColumns: "auto 1fr auto",
                gridTemplateRows: "auto 1fr auto",
                alignItems: "center",
                justifyItems: "center",
                marginTop: "10mm"
            }}
            >
            {/* Top Text */}
            <div
                style={{
                gridColumn: "1 / 4",
                fontSize: "15mm",
                textAlign: "center",
                marginBottom: "2mm", // tighter spacing
                marginTop: "10mm"
                }}
            >
                <p style={{ margin: "1mm 0" }}>{cellIndex?.activity_type_name}</p>
                {cellIndex?.activity_type_id === "7" && (
                  <p style={{ margin: "1mm 0" }}>{cellIndex?.test_tube_batch_no},{cellIndex?.swab_batch_no}</p>
                )}
            </div>
    
            {/* Left Text (Vertical) */}
            <div
                style={{
                gridRow: "2",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)", // make it bottom to top
                fontSize: "15mm",
                textAlign: "center",
                }}
            >
                <p style={{ margin: "2mm 0" }}>{cellIndex?.location_name}</p>
            </div>
    
            {/* QR Image in the center */}
            <img
                src={baseUrl + "/" + cellIndex?.qr_file_path}
                alt={`Image ${cellIndex?.production_schedule_name}`}
                style={{
                gridRow: "2",
                gridColumn: "2",
                width: "220mm",
                height: "220mm",
                objectFit: "contain",
                }}
            />
    
            {/* Right Text (Vertical) */}
            <div
                style={{
                gridRow: "2",
                writingMode: "vertical-rl",
                fontSize: "15mm",
                textAlign: "center",
                }}
            >
                <p style={{ margin: "2mm 0" }}>{(cellIndex?.user_first_name || "") + " " + (cellIndex?.user_last_name || "")}</p>
            </div>
    
            {/* Bottom Text */}
            <div
                style={{
                gridColumn: "1 / 4",
                fontSize: "15mm",
                textAlign: "center",
                marginTop: "2mm", // tighter spacing
                }}
            >
                <p style={{ margin: "1mm 0" }}>{cellIndex?.serial_number}</p>
                <p style={{ margin: "1mm 0" }}>
                {moment(cellIndex?.qr_generated_datetime).format("DD-MM-YYYY - HH:mm:ss")}
                </p>
            </div>
            </div>
        </div>
    );
  };
})}  }
  const handleDownloadBtn = () => {
      const content: any = document.getElementById("innerDiv");
      const pri: any = window.open("", "", "height=800,width=1000");

      pri.document.open();
      pri.document.write(`
          <html>
              <head>
                  <title>Print QR Codes</title>
                      <style>
                  @page { size: A4 portrait; margin: 0; }
                  body, html {
                      margin: 0;
                      padding: 0;
                      width: 210mm;
                      height: 297mm;
                  }
                  .page {
                      page-break-after: always;
                      width: 210mm;
                      height: 297mm;
                  }
              </style>
              </head>
              <body>${content.innerHTML}</body>
          </html>
      `);
      pri.document.close();

      pri.onload = () => {
          const images = pri.document.images;
          let loadedImages = 0;

          if (images.length === 0) {
              startPrint();
              return;
          }

          for (let i = 0; i < images.length; i++) {
              images[i].onload = images[i].onerror = () => {
                  loadedImages++;
                  if (loadedImages === images.length) {
                      startPrint();
                  }
              };
          }
      };

      function startPrint() {
          pri.focus();
          pri.print();
          pri.onafterprint = () => {
              pri.close();
              setQrModalShow(false);
              setActionClearAll(true);
              // setCellWidth(1);
          };
      }
  };

  //api call to get lot list
  const getLotList = async (batchId: string) => {
      let rowData: any = [];
      try {
          const response = await scheduleService.getLotListByAvailability(
              _h.isNotEmpty(batchId) ? batchId : defaultQrFormData?.batchId
          );
          if (response.status && response.statusCode === 200) {
              try {
                  if (Array.isArray(response.data) && response.data?.length > 0) {
                      rowData = response.data.map((element: any, index: number) => {
                          return {
                              id: element.id,
                              name: element.lot_code,
                              remaining_plates_count: element?.remaining_plates_for_qr
                          };
                      });
                      setLotList(rowData);
                  }
              } catch (error) {
                  console.log(error);
              }
          } else {
              setLotList([]);
          }
      } catch (error) {
          console.error("user response", error);
      }
      return rowData;
  };

  //handle onchange input QR fields
  const handleQRFieldOnChange = async (e: any) => {
      const { name, value } = e.target;

      let updatedFormData = {
          ...qrFormData,
          [name]: value,
      };

      if (name == "batchId") {
          setLotList([]);
          const selectedBatch = batchList.find((item: any) => item.id === value);
          updatedFormData = {
            ...updatedFormData,
            batchName: selectedBatch?.name || "", // set batch name
            lotId: ""
          };
   
          let lots = await getLotList(value);
          setLotList(lots);
      }
      if (name == "lotId") {
          const selectedLot = lotList.find((item: any) => item.id === value);
          updatedFormData = {
            ...updatedFormData,
            lotCode: selectedLot?.name || "", // set lot code
          };
          setTotalPlateCount(selectedLot?.remaining_plates_count || 0);
      }
      if (name == "plateType") {
          if (updatedFormData.plateType) {
              setBatchList([]);
              updatedFormData = {
                ...updatedFormData,
                batchId: "", 
              };
              getBatchList(updatedFormData.plateType);
          } else {
              setBatchList([]);
          }
      }
      if (name == "swabStick") {
          const selectedSwab = swabStickList.find((item: any) => item.id === value);
          updatedFormData = {
            ...updatedFormData,
            swabStickCode: selectedSwab?.name || "", 
          };
          setTotalSwabCount(selectedSwab?.remaining_plates_count || 0);
      }
      if (name == "salineTube") {
          const selectedSalineTube = salineTubeList.find((item: any) => item.id === value);
          updatedFormData = {
            ...updatedFormData,
            salineTubeCode: selectedSalineTube?.name || "",
          };
          setTotalSalineTubeCount(selectedSalineTube?.remaining_plates_count || 0);
      }

      setQrFormData(updatedFormData);


  };

  // handle generate QR button
  const handleGeneratePlateQR = (slno: string[]) => {
      setModalName(t("generatePlateQr.generatePlateQr"));
      const updatedPlateDetails = tableData
          .filter((item: any) => slno.includes(item.slno))
          .map((item: any, index: number) => ({
              ...item,
              slno: index + 1 // Update slno with the new value
          }));
      setOpTableData(updatedPlateDetails)
      setTotalPlatesRequired(updatedPlateDetails.length)
      setTotalSalineRequired(updatedPlateDetails.length)
      setTotalSwabRequired(updatedPlateDetails.length)
      const anyHasPlateSerialNo = updatedPlateDetails.some(item => item.plateSerialNo && item.plateSerialNo !== "");
      let firstChosedActivityId = updatedPlateDetails[0]?.activity_type_id
      const hasDifferentActivity = updatedPlateDetails.some(item => item.activity_type_id !== firstChosedActivityId)
      
      if (anyHasPlateSerialNo) {
          setToastMessage("Some plates has plate serial no.");
          setToastType("error")
          setShowToast(true)
      } else if (hasDifferentActivity) {
          setToastMessage("Please select a single activity to generate the Plate QR.");
          setToastType("error")
          setShowToast(true)
      } else {
          getPlateTypeList(updatedPlateDetails[0]?.activity_workflow_id);
          // setShowGenerateQrModal(true);
          setShowGenerateQrModalTest(true)

      }
  }

  const handleAddLotWithRemainingPlateClick = () => {
    const errors: Errors = {};
    if (!qrFormData.lotId) {
          errors.lotId = t("generatePlateQr.errors.lot");
    } else if (!qrFormData.batchId) {
          errors.batchId = t("generatePlateQr.errors.batch");
    } else {
      setQrFormData((prevFormData) => {
          const existing = prevFormData.lotIdWithRemainingPlates ?? [];
          const lotId = prevFormData.lotId;

          const selectedLot = lotList.find((l) => l.id === lotId);
          const lotCode = selectedLot?.name ?? "";
          const selectedBatch = batchList.find((b) => b.id === prevFormData.batchId);
          const batchName = selectedBatch?.name ?? "";


          let newCount = 0

          if (totalPlateCount > totalPlatesRequires) {
            newCount = totalPlatesRequires
            setTotalPlatesRequired(0)
          } else {
            newCount = totalPlateCount
            setTotalPlatesRequired(totalPlatesRequires - totalPlateCount)
          }

          // Check if lot_id already exists
          const updatedList = existing.some(item => item.lot_id === lotId)
              ? existing.map(item =>
                  item.lot_id === lotId
                      ? { ...item, plate_count: newCount, lotCode, batchName }
                      : item
                )
              : [...existing, { lot_id: lotId, plate_count: newCount, lotCode, batchName }];

          return {
              ...prevFormData,
              lotId:"",
              lotIdWithRemainingPlates: updatedList,
          };
      });
    }
    setErrors(errors);
  }

  const handleAddSalineTubeWithRemainingPlateClick = () => {
    const errors: Errors = {};
    if (!qrFormData.salineTube) {
          errors.salineTube = t("generatePlateQr.errors.salineTube");
    } else {
      setQrFormData((prevFormData) => {
          const existing : any = prevFormData.salineTubeWithRemainingPlates ?? [];
          const salineTube = prevFormData.salineTube;

          const selectedSalineTube = salineTubeList.find((l) => l.id === salineTube);
          const name = selectedSalineTube?.name ?? "";
          const expiryDate = selectedSalineTube?.expiry_date ?? "";


          let newCount = 0

          if (totalSalineTubeCount > totalSalineRequires) {
            newCount = totalSalineRequires
            setTotalSalineRequired(0)
          } else {
            newCount = totalSalineTubeCount
            setTotalSalineRequired(totalSalineRequires - totalSalineTubeCount)
          }

          // Check if lot_id already exists
          const updatedList = existing.some((item : any) => item.id === salineTube)
              ? existing.map((item : any)=>
                  item.id === salineTube
                      ? { ...item, count: newCount, name, expiryDate }
                      : item
                )
              : [...existing, { id: salineTube, count: newCount, name, expiryDate }];

          return {
              ...prevFormData,
              salineTube:"",
              salineTubeWithRemainingPlates: updatedList,
          };
      });
    }
    setErrors(errors);
  }

  const handleAddSwabStickWithRemainingPlateClick = () => {
    const errors: Errors = {};
    if (!qrFormData.swabStick) {
          errors.swabStick = t("generatePlateQr.errors.swabStick");
    } else {
      setQrFormData((prevFormData) => {
          const existing : any = prevFormData.swabWithRemainingPlates ?? [];
          const swabStick = prevFormData.swabStick;

          const selectedSwabStick = swabStickList.find((l) => l.id === swabStick);
          const name = selectedSwabStick?.name ?? "";
          const expiryDate = selectedSwabStick?.expiry_date ?? "";


          let newCount = 0

          if (totalSwabCount > totalSwabRequires) {
            newCount = totalSwabRequires
            setTotalSwabRequired(0)
          } else {
            newCount = totalSwabCount
            setTotalSwabRequired(totalSwabRequires - totalSwabCount)
          }

          // Check if lot_id already exists
          const updatedList = existing.some((item : any) => item.id === swabStick)
              ? existing.map((item : any)=>
                  item.id === swabStick
                      ? { ...item, count: newCount, name, expiryDate }
                      : item
                )
              : [...existing, { id: swabStick, count: newCount, name, expiryDate }];

          return {
              ...prevFormData,
              swabStick:"",
              swabWithRemainingPlates: updatedList,
          };
      });
    }
    setErrors(errors);
  }

   // handle remove icon click
  const handleRemovePlate = (id: string, count: number) => {
    setQrFormData((prevState) => ({
      ...prevState,
      lotIdWithRemainingPlates: prevState.lotIdWithRemainingPlates.filter(
        (plate) => plate.lot_id !== id
      ),
    }));
    setTotalPlatesRequired((prev) => prev + count);
  }

  // handle remove icon click for saline tube
  const handleRemoveSalineTube = (id: string, count: number) => {
    setQrFormData((prevState) => ({
      ...prevState,
      salineTubeWithRemainingPlates: prevState.salineTubeWithRemainingPlates.filter(
        (plate) => plate.id !== id
      ),
    }));
    setTotalSalineRequired((prev) => prev + count);
  }

  // handle remove icon click for saline tube
  const handleRemoveSwabStick = (id: string, count: number) => {
    setQrFormData((prevState) => ({
      ...prevState,
      swabWithRemainingPlates: prevState.swabWithRemainingPlates.filter(
        (plate) => plate.id !== id
      ),
    }));
    setTotalSwabRequired((prev) => prev + count);
  }

  // Flatten the lot IDs based on plate_count
  const availableLotIds : any = [];
  qrFormData.lotIdWithRemainingPlates.forEach(lot => {
    for (let i = 0; i < lot.plate_count; i++) {
      availableLotIds.push(lot.lot_id);
    }
  });

  // Flatten test_tube_batch_ids based on plate_count
  const availableTestTubeBatchIds: string[] = [];
  qrFormData.salineTubeWithRemainingPlates.forEach(item => {
    for (let i = 0; i < item.count; i++) {
      availableTestTubeBatchIds.push(item.id);
    }
  });

  // Flatten swab_batch_ids based on plate_count
  const availableSwabBatchIds: string[] = [];
  qrFormData.swabWithRemainingPlates.forEach(item => {
    for (let i = 0; i < item.count; i++) {
      availableSwabBatchIds.push(item.id);
    }
  });

  //clear modal on close - QR
  const handleQRFormClose = () => {
      setQrFormData(defaultQrFormData);
      setSelectedRow(defaultFormData);
      // setShowGenerateQrModal(false);
      setShowGenerateQrModalTest(false)
      setOpTableData([]);
      setTotalPlateCount(0);
      setTotalSwabCount(0);
      setTotalSalineTubeCount(0);
  };

  // Function to check QR generation status
  const checkQRStatus = async (processId: string) => {
    try {
      const checkStatus = async () => {
        const statusResponse = await scheduleService.checkQrGenerationStatus(processId);
        
        if (statusResponse?.check_flag === 1) {
          // QR generation completed
          setToastType("success");
          setLoader(false);
          setToastMessage(statusResponse.message || 'QR codes generated successfully');
          handleQRFormClose();
          setActionClearAll(true);
          getOperatorScheduleList();
          getSwabStickList();
          getSalineTubeList();
          setShowToast(true);
        } else if (statusResponse?.check_flag === 2) {
          // QR generation failed
          setLoader(false);
          setToastType("error");
          setToastMessage(statusResponse.message || 'QR code generation failed');
          setShowToast(true);
          handleQRFormClose();
          setActionClearAll(true);
          getOperatorScheduleList();
          getSwabStickList();
          getSalineTubeList();
        } else {
          // QR generation still in progress, check again after 3 seconds
          setTimeout(checkStatus, 3000);
        }
      };
      
      // Start checking status
      await checkStatus();
    } catch (error) {
      console.error('Error checking QR generation status:', error);
      setLoader(false);
      setToastType("error");
      setToastMessage('Error checking QR generation status');
      setShowToast(true);
    }
  };

  //handle add area submit api call
  const handleQRFormSubmit = async (selectedOperators: any[]) => {
    if (_h.isNotEmpty(selectedOperators)) {
      let totalQuantity = 0;
      let request: any = [];
      
      Object.values(selectedOperators).forEach((val, index) => {
        if (availableLotIds[index]) {
          request.push({
            lot_id: availableLotIds[index],
            test_tube_batch_id: availableTestTubeBatchIds[index],
            swab_batch_id: availableSwabBatchIds[index],
            quantity: 1,
            master_activity_id: val?.activity_type_id,
            location_id: val.location_id,
            operator_id: val.user_master_id || userId,
            schedule_operator_id: val.id,
          });
        } else {
          console.warn('Not enough lot_ids for selectedOperators');
        }
        totalQuantity = index + 1;
      });
      
      setLoader(true);
      const dataToSend = {
        operators: request,
        lot_id: qrFormData.lotId,
        totalQuantity: totalQuantity,
        interface_name: modalName,
        lot_details: qrFormData.lotIdWithRemainingPlates,
        test_tube_details: qrFormData.salineTubeWithRemainingPlates,
        swab_stick_details: qrFormData.swabWithRemainingPlates
      };
      
      try {
        const response = await scheduleService.generateBulkPlateQrV2(dataToSend);
        
        if (response.status && response.statusCode === 200) {
          // Show initial success message
          setToastType("info");
          setToastMessage(response.message || 'QR generation started. Please wait...');
          setShowToast(true);
          
          // Start checking QR generation status if we have a process_id
          if (response.process_id) {
            await checkQRStatus(response.process_id);
          } else {
            // Fallback to old behavior if no process_id
            setLoader(false);
            setToastType("success");
            setToastMessage(response.message || 'QR codes generated successfully');
            handleQRFormClose();
            setActionClearAll(true);
            getOperatorScheduleList();
            getSwabStickList();
            getSalineTubeList();
            setShowToast(true);
          }
        } else {
          setToastType("error");
          setLoader(false);
          setToastMessage(response.message || 'Failed to start QR generation');
          setShowToast(true);
        }
      } catch (error) {
        console.error('Error generating QR codes:', error);
        setLoader(false);
        setToastType("error");
        setToastMessage('An error occurred while generating QR codes');
        setShowToast(true);
      }
    }
  }; 

  //handle area validation starts here
  const handleQRFormValidation = (selectedOperators: any[]) => {
      const errors: Errors = {};
      // if (!qrFormData.activity_type_id) {
      //   errors.activity_type_id = "Please select an activity type";
      // }
      if (!qrFormData.batchId) {
          errors.batchId = t("generatePlateQr.errors.batch");
      }
      if (totalPlatesRequires > 0) {
          errors.lotId = t("generatePlateQr.errors.remainingLot");
      }
      if (opTableData[0]?.activity_type_id === "7" && totalSalineRequires > 0) {
          errors.salineTube = t("generatePlateQr.errors.salineTubeAdd");
      }
      if (opTableData[0]?.activity_type_id === "7" && totalSwabRequires > 0) {
          errors.swabStick = t("generatePlateQr.errors.swabStickAdd");
      }
      if (!qrFormData.plateType) {
          errors.plateType = t("generatePlateQr.errors.plateType");
      }
      // if (!qrFormData.mediaType) {
      //     errors.mediaType = t("generatePlateQr.errors.mediaType");
      // }
      // if (!qrFormData.nextSerialNo) {
      //   errors.nextSerialNo = "Please enter next serial No";
      // }
      // if (!qrFormData.plateCount) {
      //   errors.plateCount = "Please enter plate count";
      // }
      if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
      }
      // if (!_h.arrayHasData(selectedOperators)) {
      // setToastType("error");
      // setToastMessage("Please select atleast one operator");
      // setShowToast(true);
      // return;
      // }
      setErrors({});
      handleQRFormSubmit(opTableData);
  };

  //handle single and multi QR download button click
  const handleQrDownload = async () => {
      const selectedOperators = opTableData.filter((item: any) =>
          selectedOpSlNo.includes(item.slno)
      );
      handleQRFormValidation(selectedOperators);
  };

  const handleSelectChange = (event: any) => {
    const { name, value } = event.target;
    let newValue = value;

    // Handle "Select All" toggle
    if (value.includes('ALL')) {
      newValue = isAllSelected ? [] : allAreaNames;
    }

    handleAddFieldOnChange({
      target: {
        name,
        value: newValue,
      },
    });
  };


  //handle user details for submit handling
  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");
    if (storedData) {
      var storedObject = JSON.parse(storedData);
      getPermissionByRole(storedObject[0].role_master_id);
      setUserId(storedObject[0].id)
    }
    
    getOperatorScheduleList();
    getProductionSchedules("");
    get_work_shifts();
    getActivityTypeList();
    getMasterUserList();
    getAreaList("8,12,9,6,17", "");
    getProductList();
    geAreaTypeList();
    listGrade();
    getMediaType();
    getSwabStickList();
    getSalineTubeList();
    getProductionSchedule("")
    // getBatchList("", "");

    setUseEffectRequired(false);
  }, [useEffectRequired]);


  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t("generatePlateQr.generatePlateQr")} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />

      <div className="me-3" style={{ marginTop: "10px" }}>
        <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
          <CustomTable
            tableHead={t("generatePlateQr.assignedTask")}
            data={tableData}
            columns={columns}
            // isEditable={permission?.includes("edit_operator_schedule")}
            isEditable={false}
            totalElements={totalElements}
            isActionVisible={true}
            isViewVisible={false}
            onViewClick={handleViewClick}
            isSeachable={false}
            // addButton={permission?.includes("add_operator_schedule")}
            // addButtonText='Assign Operator'
            // onAddClick={handleAssignOperatorClick}
            actionCheckOrangeButton={true}
            actionCheckOrangeBtnText={t("generatePlateQr.downloadQr")}
            onActionCheckOrangeButtonClick={handleDownloadQR}
            actionCheckOrangeButton2={true}
            actionCheckOrangeBtnText2={t("generatePlateQr.generatePlateQr")}
            onActionCheckOrangeButtonClick2={handleGeneratePlateQR}
            actionCheckOrangeButton3={permission?.includes("add_operator_schedule")}
            actionCheckOrangeBtnText3={t("scheduleOperator.tableHead")}
            onActionCheckOrangeButtonClick3={handleAssignOperatorClick}
            onFilterClick={handleFilter}
            onSortClick={handleSort}
            isToggleStatus={false}
            onStatusChange={handleStatusChange}
            isQrDownloadable={false}
            onEditClick={handleEditClick}
            showQrGenerateButton={false}
            showBlueBtn={permission?.includes("add_operator_schedule")}
            blueBtnText={t("scheduleOperator.add")}
            onBlueBtnClick={handleAddClick}
            showToDateFilter={true}
            showFromDateFilter={true}
            dateType='date'
            discardButton={permission?.includes("add_operator_schedule")}
            discardButtonText={t("scheduleOperator.reassign_operator")}
            onDiscardClick={handleReassignOperator}
            // actionCheckOrangeButton2={permission?.includes("add_operator_schedule")}
            // actionCheckOrangeBtnText2={t("scheduleOperator.reassign_operator")}
            // onActionCheckOrangeButtonClick2={handleReassignOperator}
            showFullFilters={true}
            ActivityType={activityType}
            process={processList}
            assignee={usersList}
            areaDropList={areaData}
            prodScheduleList={prodScheduleList}
            clearAll={actionClearAll}
            locationList={filterLocationList}
            productList={productList}
            removeSortList={sortRemoveList}
          />
        </div>
        <div>
          <Pagination
            page={page}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {/*modal for add Operator schedule */}
      <Modal
        className="top-right-modal-md"
        centered={false}
        show={showAddModal}
      // size='lg'
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{modalName}</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleFormClose()}
              className="p-2 mx-3 my-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          <div style={{ "height": "80vh", "overflow": "scroll" }}>
            <div className="selectWrap-new">
              

              {/* <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.product_name")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                 <select
                  id="product_name"
                  value={masterFormData?.product_name}
                  name="product_name"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {productList.map((val) => (
                    <option key={val.id} value={val.name}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.productName && (
                  <p className="errorText">{errors.productName}</p>
                )}
              </div> */}

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleOperator.activityType")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id="activity_type_id"
                  value={masterFormData?.activity_type_id}
                  name="activity_type_id"
                  onChange={handleAddFieldOnChange}
                // disabled={true}
                >
                  <option value="">{t("common.select")}</option>
                  {activityType
                    .filter((val) => val.id !== "3")
                    .map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.activity_type_id && (
                  <p className="errorText">{errors.activity_type_id}</p>
                )}
              </div>

                 {/* area type */}
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.areaType")}
                   {!disableArea && (<span style={{ color: "red" }}>*</span>)}
                </label>
                <br />
                <select
                  id="areaType"
                  value={masterFormData?.areaType}
                  name="areaType"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {areaType.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.title}
                    </option>
                  ))}
                </select>
                {errors.areaType && <p className="errorText">{errors.areaType}</p>}
              </div>

              {/* grade type */}
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleProduction.gradeType")}
                  {!disableArea && (<span style={{ color: "red" }}>*</span>)}
                </label>
                <br />
                <select
                  id="gradeType"
                  value={masterFormData?.gradeType}
                  name="gradeType"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {grade.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.grade}
                    </option>
                  ))}
                </select>
                {errors.gradeType && <p className="errorText">{errors.gradeType}</p>}
              </div>

            </div>

            <div className="selectWrap-new">

             

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleOperator.area")}
                  {/* <span style={{ color: "red" }}>*</span> */}
                </label>
                <br />
                <select
                  id="area_id"
                  value={masterFormData?.area_id}
                  name="area_id"
                  onChange={handleAddFieldOnChange}
                  disabled={disableArea}
                >
                  <option value="">{t("common.select")}</option>
                  {areaData.map((val: any) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {/* <FormControl sx={{width: 195}}>
                  <Select
                    multiple
                    displayEmpty
                    value={masterFormData?.area_id}
                    onChange={handleAddFieldOnChange}
                    name="area_id"
                    input={<OutlinedInput/>}
                    sx={{height: 38, paddingTop: 2}}
                    inputProps={{ 'aria-label': 'Without label' }}
                  // MenuProps={MenuProps}
                >
                  {areaData.map((val: any) => {
                    const isSelected = masterFormData.area_id.includes(val.name);
                    return (
                      <MenuItem
                        key={val.id}
                        value={val.id}
                          sx={{
                          backgroundColor: isSelected ? '#e3f2fd' : 'inherit',
                          '&.Mui-selected': {
                            backgroundColor: '#bbdefb',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: '#90caf9',
                          },
                        }}
                      >
                        {val.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                </FormControl> */}
                
                {/* {errors.location_id && (
                <p className="errorText">{errors.location_id}</p>
              )} */}
              </div>

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  Production Schedule
                  {masterFormData.activity_type_name !== "Plate Sampling" && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </label>
                <br />
                <select
                  id="productionSchedule"
                  value={masterFormData?.productionSchedule}
                  name="productionSchedule"
                  onChange={handleAddFieldOnChange}
                // disabled={true}
                >
                  <option value="">{t("common.select")}</option>
                  {prodScheduleLists.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.production_schedule_name}
                    </option>
                  ))}
                </select>
                {errors.productionSchedule && (
                  <p className="errorText">{errors.productionSchedule}</p>
                )}
              </div>

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleFrequency.quantity")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  id="plate_count"
                  value={masterFormData?.plate_count}
                  name="plate_count"
                  type='number'
                  min={1}
                  onChange={handleAddFieldOnChange}
                />
                {errors.plate_count && (
                  <p className="errorText">{errors.plate_count}</p>
                )}
              </div>

            </div>

            <div className="selectWrap-new">
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleOperator.location")}
                  {!disableArea && (<span style={{ color: "red" }}>*</span>)}
                </label>
                <br />
                {/* <select
                  id="location_id"
                  value={masterFormData?.location_id}
                  name="location_id"
                  onChange={handleAddFieldOnChange}
                  disabled={disableArea}
                >
                  <option value="">{t("common.select")}</option>
                  {locationList?.map((val: any) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select> */}
                <FormControl sx={{width: 195}}>
                  <Select
                    multiple
                    displayEmpty
                    value={masterFormData?.location_id}
                    onChange={handleSelectChange}
                    name="location_id"
                    input={<OutlinedInput/>}
                    disabled={disableArea}
                    sx={{height: 38, paddingTop: 2}}
                    inputProps={{ 'aria-label': 'Without label' }}
                  // MenuProps={MenuProps}
                >
                  <MenuItem 
                    value="ALL"
                    sx={{
                        backgroundColor: isAllSelected ? '#e3f2fd' : 'inherit',
                        '&.Mui-selected': {
                          backgroundColor: '#bbdefb',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: '#90caf9',
                        },
                      }}
                  >
                    Select ALL
                  </MenuItem>
                  {locationList.map((val: any) => {
                    const isSelected = masterFormData.location_id.includes(val.id);
                    return (
                      <MenuItem
                        key={val.id}
                        value={val.id}
                          sx={{
                          backgroundColor: isSelected ? '#e3f2fd' : 'inherit',
                          '&.Mui-selected': {
                            backgroundColor: '#bbdefb',
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: '#90caf9',
                          },
                        }}
                      >
                        {val.name}
                      </MenuItem>
                    );
                  })}
                </Select>
                </FormControl>
                {errors.location_id && (
                  <p className="errorText">{errors.location_id}</p>
                )}
              </div>
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleOperator.work_shift")}
                  {/* <span style={{ color: "red" }}>*</span> */}
                </label>
                <br />
                <select
                  id="work_shift_id"
                  value={masterFormData?.work_shift_id}
                  name="work_shift_id"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {workShiftList.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.work_shift_id && (
                  <p className="errorText">{errors.work_shift_id}</p>
                )}
              </div>
              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleOperator.operator")}
                  {/* <span style={{ color: "red" }}>*</span> */}
                </label>
                <br />
                <select
                  id="user_master_id"
                  value={masterFormData?.user_master_id}
                  name="user_master_id"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {usersList.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.user_master_id && (
                  <p className="errorText">{errors.user_master_id}</p>
                )}
              </div>
            </div>

            <div className="selectWrap-new">
              <div className="form-group my-1 mx-3 px-2" >
                <label>
                  {t("scheduleOperator.start_date_time")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <input
                  type="date"
                  name="start_date_time"
                  id="start_date_time"
                  // value={
                  //   _h.isNotEmpty(masterFormData.start_date_time)
                  //     ? moment(
                  //         masterFormData.start_date_time,
                  //         "DD-MM-YYYY - HH:mm:ss"
                  //       ).format("YYYY-MM-DDTHH:mm")
                  //     : ""
                  // }
                  value={moment(masterFormData?.start_date_time).format("YYYY-MM-DD")}
                  onChange={handleAddFieldOnChange}
                  min={moment(currentDate).format("YYYY-MM-DD")}
                  // className="filter-input"
                  style={{ "width": "190px" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Tab",
                      "Enter",
                      "Escape",
                    ];
                    if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => e.preventDefault()}


                // value={
                //   _h.isNotEmpty(reassignFormData.end_date_time)
                //     ? moment(
                //         reassignFormData.end_date_time,
                //         "DD-MM-YYYY - HH:mm:ss"
                //       ).format("YYYY-MM-DDTHH:mm")
                //     : ""
                // }

                />
                {errors.start_date_time && (
                  <p className="errorText">{errors.start_date_time}</p>
                )}
              </div>

              <div className="form-group my-1 mx-3 px-2">
                <label>
                  {t("scheduleFrequency.workflow")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id="activity_workflow_id"
                  value={masterFormData?.activity_workflow_id}
                  name="activity_workflow_id"
                  onChange={handleAddFieldOnChange}
                >
                  <option value="">{t("common.select")}</option>
                  {workFlowList.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.name}
                    </option>
                  ))}
                </select>
                {errors.workflow_id && (
                  <p className="errorText">{errors.workflow_id}</p>
                )}
              </div>


            </div>
            <div className="selectWrap-new">
              {!masterFormData.id && (
                <div className="form-group mx-3 px-2">
                  <label></label>
                  <br />
                  <button
                    onClick={() => updateSelectedOperatorTableData()}
                    className="squareOrangeBtn3"
                  >
                    {t("buttons.add")}
                  </button>
                </div>
              )}
              {masterFormData.id && (
                <div className="form-group mx-3 px-2">
                  <label htmlFor="" className="ReasonLabel">
                    {t("userManagement.reason")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <input
                    id="reason"
                    value={masterFormData.reason}
                    name="reason"
                    type="text"
                    placeholder={t("userManagement.reason")}
                    className="reasonClass"
                    onChange={handleAddFieldOnChange}
                  />
                  {errors.reason && <p className="errorText">{errors.reason}</p>}
                </div>
              )}
            </div>

            {!masterFormData.id && (
              <div className="me-3" style={{ marginTop: "1px" }}>
                <div className=" mx-3 pe-2" style={{ height: "25vh" }}>
                  <CustomTable
                    tableHead={t("scheduleOperator.taskAssigned")}
                    data={addedOperators}
                    columns={addedOperatorsColumns}
                    isEditable={false}
                    totalElements={addedOperators.length}
                    isActionVisible={false}
                    isViewVisible={false}
                    // onViewClick={handleViewClick}
                    isSeachable={false}
                    // addButton={permission?.includes("add_production_schedule")}
                    // addButtonText={t("scheduleProduction.add")}
                    // onFilterClick={handleFilter}
                    // onSortClick={handleSort}
                    // onAddClick={handleAddClick}
                    isToggleStatus={false}
                    // onStatusChange={handleStatusChange}
                    isQrDownloadable={false}
                    // onEditClick={handleEditClick}
                    showQrGenerateButton={false}
                    actionButtons={[
                      {
                        thLabel: t("scheduleOperator.remove"),
                        buttonLabel: t("scheduleOperator.remove"),
                        handleAction: (row: any) => {
                          // handleQRGenerate(row);
                          setAddedOperators((prevOperators) =>
                            prevOperators.filter((operator) => operator.slno !== row.slno)
                          );
                        },
                      },
                    ]}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="bottomArea">
            <button
              onClick={() => handleFormClose()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => handleFormValidation()}
              className="squareOrangeBtn3"
            >
              {t("buttons.submit")}
            </button>
          </div>
          {loader && <CustomLoader />}
        </div>
      </Modal>

      {/*modal for reassign Operator schedule */}
      <Modal
        className="top-right-modal-md"
        centered={false}
        show={showReassignModal}
      // size='lg'
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{modalName}</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleFormClose()}
              className="p-2 mx-3 my-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          <div className="selectWrap-new">
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.operator")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="user_master_id"
                value={reassignFormData?.user_master_id}
                name="user_master_id"
                onChange={handleReassignFieldOnChange}
              >
                <option value="">{t("common.select")}</option>
                {usersList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.user_master_id && (
                <p className="errorText">{errors.user_master_id}</p>
              )}
            </div>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.fromDate")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                type="date"
                name="start_date_time"
                id="start_date_time"
                min={
                  _h.isNotEmpty(currentDate)
                    ? moment(
                      currentDate,
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : ""
                }
                value={
                  _h.isNotEmpty(reassignFormData.start_date_time)
                    ? moment(
                      reassignFormData.start_date_time,
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : ""
                }
                onChange={handleReassignFieldOnChange}
                className="filter-input"
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Tab",
                    "Enter",
                    "Escape",
                  ];
                  if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => e.preventDefault()}
              />
              {errors.start_date_time && (
                <p className="errorText">{errors.start_date_time}</p>
              )}
            </div>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.toDate")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <input
                type="date"
                name="end_date_time"
                id="end_date_time"
                min={
                  _h.isNotEmpty(reassignFormData.start_date_time)
                    ? moment(
                      (reassignFormData.start_date_time),
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : moment(
                      (currentDate),
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                }
                value={
                  _h.isNotEmpty(reassignFormData.end_date_time)
                    ? moment(
                      reassignFormData.end_date_time,
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : ""
                }
                onChange={handleReassignFieldOnChange}
                className="filter-input"
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Tab",
                    "Enter",
                    "Escape",
                  ];
                  if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => e.preventDefault()}
              />
              {errors.end_date_time && (
                <p className="errorText">{errors.end_date_time}</p>
              )}
            </div>
          </div>

          <div className="selectWrap-new">
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.assignUser")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="assignUser_id"
                value={reassignFormData?.assignUser_id}
                name="assignUser_id"
                onChange={handleReassignFieldOnChange}
              >
                <option value="">{t("common.select")}</option>
                {usersList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.assignUser_id && (
                <p className="errorText">{errors.assignUser_id}</p>
              )}
            </div>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.newStartDate")}
                {/* <span style={{ color: "red" }}>*</span> */}
              </label>
              <br />
              <input
                type="date"
                name="new_start_time"
                id="new_start_time"
                min={
                  _h.isNotEmpty(currentDate)
                    ? moment(
                      currentDate,
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : ""
                }
                value={
                  _h.isNotEmpty(reassignFormData.new_start_time)
                    ? moment(
                      reassignFormData.new_start_time,
                      "DD-MM-YYYY - HH:mm:ss"
                    ).format("YYYY-MM-DD")
                    : ""
                }
                onChange={handleReassignFieldOnChange}
                className="filter-input"
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Tab",
                    "Enter",
                    "Escape",
                  ];
                  if (!allowedKeys.includes(e.key) && !ALLOW_CUSTOM_DATE) {
                    e.preventDefault();
                  }
                }}
                onPaste={(e) => e.preventDefault()}
              />
              {errors.newStartDate && (
                <p className="errorText">{errors.newStartDate}</p>
              )}
            </div>
            <div className="form-group my-1 mx-3 px-2">
                  <label>
                    {t("userManagement.reason")}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <input
                    id="reason"
                    value={reassignFormData.reason}
                    name="reason"
                    type="text"
                    placeholder={t("userManagement.reason")}
                    className="reasonClass"
                    onChange={handleReassignFieldOnChange}
                  />
                  {errors.reason && (
                <p className="errorText">{errors.reason}</p>
              )}
                </div>
          </div>

          <div className="me-3" style={{ marginTop: "10px" }}>
            <div className=" mx-3 pe-2" style={{ height: "35vh" }}>
              <CustomTable
                tableHead={t("scheduleOperator.operatorSchedules")}
                data={reassignOperatorSchedules}
                columns={reassignOperatorsColumns}
                isEditable={false}
                totalElements={reassignOperatorSchedules.length}
                isActionVisible={true}
                isViewVisible={false}
                isSeachable={false}
                isToggleStatus={false}
                isQrDownloadable={false}
                showQrGenerateButton={false}
                onActionClick={handleReassignActionClick}
              />
            </div>
          </div>

          <div className="bottomArea">
            <button
              onClick={() => handleFormClose()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => reAssignFieldOnSubmit()}
              disabled={selectedOperatorIds.length <= 0}
              className={`squareOrangeBtn3 ${selectedOperatorIds.length <= 0 && "squareOrangeBtn6Disabled"}`}
            // className="squareOrangeBtn3 squareOrangeBtn3Disabled"
            >
              {t("buttons.submit")}
            </button>
          </div>
        </div>
      </Modal>

      {/* assign operator modal */}
      <Modal
        className="top-right-modal-md"
        centered={false}
        show={showAssignModal}
      >
        <div>
          <div className="modalHead">
            <p className="modalHeadText ms-3 pt-3 p-2">{modalName}</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleFormClose()}
              className="p-2 mx-3 my-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>

          <div className='selectWrap-new'>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.work_shift")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="work_shift_id"
                value={masterFormData?.work_shift_id}
                name="work_shift_id"
                onChange={handleAddFieldOnChange}
              >
                <option value="">{t("common.select")}</option>
                {workShiftList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.work_shift_id && (
                <p className="errorText">{errors.work_shift_id}</p>
              )}
            </div>
            <div className="form-group my-1 mx-3 px-2">
              <label>
                {t("scheduleOperator.users")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <select
                id="user_master_id"
                value={masterFormData?.user_master_id}
                name="user_master_id"
                onChange={handleAddFieldOnChange}
              >
                <option value="">{t("common.select")}</option>
                {usersList.map((val) => (
                  <option key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </select>
              {errors.user_master_id && (
                <p className="errorText">{errors.user_master_id}</p>
              )}
            </div>
          </div>


          <div className="bottomArea">
            <button
              onClick={() => handleFormClose()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => assignFieldOnSubmit()}
              className="squareOrangeBtn3"
            >
              {t("buttons.submit")}
            </button>
          </div>
          {loader && <CustomLoader />}
        </div>
      </Modal>

       {/*modal for download QR*/}
      <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={qrModalShow}
      >
          <Modal.Header closeButton onClick={() => handleCloseQrModal()}>
              <Modal.Title id="contained-modal-title-vcenter">
                  {t("buttons.download_qr")}
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p>Selected {selectedSlnoLen} plate(s) for download QR</p>
              <div className="selectWrap">
                  {/* <div className="form-group my-1">
                      <label>{t("areaManagement.cell_width")}</label>
                      <br />
                      <input
                          type="number"
                          id="cellWidth"
                          value={cellWidth}
                          min="1"
                          onChange={(e) => {
                              const value = parseInt(e.target.value);
                              if (value > 0) {
                                  setCellWidth(value); // Update state only if value is greater than zero
                              }
                          }}
                      />
                  </div> */}
              </div>
              <div
                  id="innerDiv"
                  hidden
                  style={{
                      border: "1px solid black",
                      padding: "5px",
                      margin: "5px",
                      overflow: "scroll",
                      height: "80vh",
                  }}
              >
                  {createGrid()}
              </div>
          </Modal.Body>
          <Modal.Footer>
              <Button className='squareOrangeBtn3' onClick={() => handleDownloadBtn()}>
                  {t("buttons.download")}
              </Button>
              <Button className='modalCancelBtn' onClick={() => printWithZebraPrinter(zplList)}>
                  {t('buttons.print')}
              </Button>
          </Modal.Footer>
      </Modal>

       {/*modal for generate QR */}
      <Modal
          className="top-right-modal"
          centered={false}
          show={showGenerateQrModal}
          size='lg'
      >
          {loader && <CustomLoader />}
          <div>
              <div className="modalHead">
                  <p className="modalHeadText ms-3 pt-3 p-2">
                      {modalName}
                  </p>
                  <div
                      style={{ cursor: "pointer" }}
                      onClick={() => handleQRFormClose()}
                      className="p-2 mx-3 my-2 "
                  >
                      <TfiClose fill="#FFFFFF" />
                  </div>
              </div>
              <div className="selectWrap-new">
                  <div className="form-group my-1 mx-3 px-2">
                  <label htmlFor="">{t('plateInventory.plateType')}<span style={{ color: 'red' }}>*</span></label>
                      <br />
                      <select
                      id="plateType"
                      // value={addPlateData.plateType}
                      name="plateType"
                      onChange={handleQRFieldOnChange}
                      >
                      <option value="">{t('common.select')}</option>
                      {plateTypes.map((obj: any, index) => (
                          <option key={index} value={obj?.id}>
                          {obj?.plate_type}
                          </option>
                      ))}
                      </select>
                      {errors.plateType && <p className="errorText">{errors.plateType}</p>}
                  </div>
                  {/* <div className="form-group my-1 mx-3 px-2">
                      <label htmlFor="">{t('plateInventory.mediaType')}<span style={{ color: 'red' }}>*</span></label>
                      <br />
                      <select
                      id="mediaType"
                      // value={addPlateData.mediaType}
                      name="mediaType"
                      onChange={handleQRFieldOnChange}
                      >
                      <option value="">{t('common.select')}</option>
                      {mediaType.map((obj: any, index) => (
                          <option key={index} value={obj?.id}>
                          {obj?.name}
                          </option>
                      ))}
                      </select>
                      {errors.mediaType && <p className="errorText">{errors.mediaType}</p>}
                  </div> */}
                  <div className="form-group my-1 mx-2 px-2">
                      <label>
                          {t("scheduleProduction.batch")}
                          <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <select
                          id="batchId"
                          name="batchId"
                          onChange={handleQRFieldOnChange}
                      >
                          <option value="">{t("common.select")}</option>
                          {batchList.map((val) => (
                              <option key={val.id} value={val.id}>
                                  {val.name}
                              </option>
                          ))}
                      </select>
                      {errors.batchId && <p className="errorText">{errors.batchId}</p>}
                  </div>
                  <div className="form-group my-1 mx-2 px-2">
                      <label>
                          {t("scheduleProduction.lot")}
                          <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <select id="lotId" name="lotId" value={qrFormData.lotId} onChange={handleQRFieldOnChange}>
                          <option value="">{t("common.select")}</option>
                            {lotList.map((val) => {
                                const isDisabled = qrFormData?.lotIdWithRemainingPlates?.some(
                                    (item) => item.lot_id === val.id
                                );

                                return (
                                    <option key={val.id} value={val.id} disabled={isDisabled}>
                                        {val.name}
                                    </option>
                                );
                            })}
                          {/* {lotList.map((val) => (
                              <option key={val.id} value={val.id}>
                                  {val.name}
                              </option>
                          ))} */}
                      </select>
                      {errors.lotId && <p className="errorText">{errors.lotId}</p>}
                  </div>
                  <div className="form-group my-1 ms-3">
                      <label className='mb-1'>
                          {t("scheduleProduction.totalPlatesNeeded")}
                      </label>
                      <br />
                      <input
                          id="plateCount"
                          name="plateCount"
                          type="text"
                          placeholder={t("scheduleProduction.totalPlatesNeeded")}
                          disabled={true}
                          style={{"width": "110px"}}
                          value={totalPlateCount}
                      />
                  </div>
                  <div className="form-group my-1 mx-2 px-2">
                    <label></label>
                    <br />
                    <button
                      onClick={() => handleAddLotWithRemainingPlateClick()}
                      className="squareOrangeBtn3"
                      style={{ opacity: totalPlatesRequires <= 0 ? 0.3 : 1 }}
                      disabled={totalPlatesRequires <= 0 ? true : false}
                    >
                      {t("buttons.add")}
                    </button>
                  </div>

              </div>

              {opTableData[0]?.activity_type_id === "7" && (
              <div className="selectWrap-new">
                  <div className="form-group my-1 mx-3 px-2">
                      <label>
                          {t("testTubeConfiguration.test_tube")}
                          <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <select id="salineTube" name="salineTube" value={qrFormData.salineTube} onChange={handleQRFieldOnChange}>
                          <option value="">{t("common.select")}</option>
                              {/* {salineTubeList.map((val) => (
                                  <option key={val.id} value={val.id}>
                                      {val.name}
                                  </option>
                              ))} */}
                              {salineTubeList.map((val) => {
                                const isDisabled = qrFormData?.salineTubeWithRemainingPlates?.some(
                                    (item) => item.id === val.id
                                );

                                return (
                                    <option key={val.id} value={val.id} disabled={isDisabled}>
                                        {val.name}
                                    </option>
                                );
                              })}
                      </select>
                      {errors.salineTube && <p className="errorText">{errors.salineTube}</p>}
                  </div>
                  <div className="form-group my-1 mx-2 px-2">
                      <label className='mb-1'>
                          {t("scheduleProduction.remainingTube")}
                      </label>
                      <br />
                      <input
                          type="text"
                          placeholder={t("scheduleProduction.remainingTube")}
                          style={{"width": "110px"}}
                          disabled={true}
                          value={totalSalineTubeCount}
                      />
                  </div>
                  <div className="form-group my-1">
                    <label></label>
                    <br />
                    <button
                      onClick={() => handleAddSalineTubeWithRemainingPlateClick()}
                      className="squareOrangeBtn3"
                      style={{ opacity: totalSalineRequires <= 0 ? 0.3 : 1 }}
                      disabled={totalSalineRequires <= 0 ? true : false}
                    >
                      {t("buttons.add")}
                    </button>
                  </div>

                  <div className="form-group my-1 mx-3 px-2">
                      <label>
                          {t("swabStickInventry.swabStick")}
                          <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <select id="swabStick" name="swabStick" value={qrFormData.swabStick} onChange={handleQRFieldOnChange}>
                          <option value="">{t("common.select")}</option>
                          {/* {swabStickList.map((val) => (
                              <option key={val.id} value={val.id}>
                                  {val.name}
                              </option>
                          ))} */}
                          {swabStickList.map((val) => {
                            const isDisabled = qrFormData?.swabWithRemainingPlates?.some(
                                (item) => item.id === val.id
                            );

                            return (
                                <option key={val.id} value={val.id} disabled={isDisabled}>
                                    {val.name}
                                </option>
                            );
                          })}
                      </select>
                      {errors.swabStick && <p className="errorText">{errors.swabStick}</p>}
                  </div>
                  <div className="form-group my-1 mx-2 px-2">
                      <label className='mb-1'>
                          {t("scheduleProduction.remainingStick")}
                      </label>
                      <br />
                      <input
                          type="text"
                          placeholder={t("scheduleProduction.remainingStick")}
                          style={{"width": "110px"}}
                          disabled={true}
                          value={totalSwabCount}
                      />
                  </div>
                  <div className="form-group my-1">
                    <label></label>
                    <br />
                    <button
                      onClick={() => handleAddSwabStickWithRemainingPlateClick()}
                      className="squareOrangeBtn3"
                      style={{ opacity: totalSwabRequires <= 0 ? 0.3 : 1 }}
                      disabled={totalSwabRequires <= 0 ? true : false}
                    >
                      {t("buttons.add")}
                    </button>
                  </div>

              </div>
              )}

              <div style={{"height": "60vh", "overflow": "scroll"}}>
              {qrFormData?.lotIdWithRemainingPlates.length > 0 && (
                <div className='ms-3' style={{width: "70%", "height": "20vh", "overflow": "scroll"}}>
                <table className="table">
                <thead >
                    <tr>
                    <th>SL No</th>
                    <th>Batch Name</th>
                    <th>Lot Code</th>
                    <th>Plates Count</th>
                    <th></th>
                    </tr>
                </thead>
                <tbody>
                    {qrFormData?.lotIdWithRemainingPlates.map((obj: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{obj?.batchName}</td>
                          <td>{obj?.lotCode}</td>
                          <td>{obj?.plate_count}</td>
                          <td className="tableHeadData" ><CiCircleRemove 
                            onClick={() => handleRemovePlate(obj.lot_id, obj?.plate_count)} 
                            fontSize={25} 
                            color="red"
                            style={{"cursor": "pointer"}}
                          /></td>
                        </tr>
                      );
                    })}
                </tbody>
                </table>
                </div>
              )}

              <div className="text-center mx-2">
                <div className="row justify-content-start">
                  {qrFormData?.salineTubeWithRemainingPlates.length > 0 && (
                    <div className='col-6' style={{"height": "20vh", "overflow": "scroll"}}>
                    <table className="table">
                    <thead >
                        <tr>
                        <th>SL No</th>
                        <th>Saline Tube</th>
                        <th>Count</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {qrFormData?.salineTubeWithRemainingPlates.map((obj: any, index: number) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{obj?.name}</td>
                              <td>{obj?.count}</td>
                              <td className="tableHeadData" ><CiCircleRemove 
                                onClick={() => handleRemoveSalineTube(obj.id, obj?.count)} 
                                fontSize={25} 
                                color="red"
                                style={{"cursor": "pointer"}}
                              /></td>
                            </tr>
                          );
                        })}
                    </tbody>
                    </table>
                    </div>
                  )}
                  {qrFormData?.swabWithRemainingPlates.length > 0 && (
                    <div className='col-6' style={{"height": "20vh", "overflow": "scroll"}}>
                    <table className="table">
                    <thead >
                        <tr>
                        <th>SL No</th>
                        <th>Swab Stick</th>
                        <th>Count</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {qrFormData?.swabWithRemainingPlates.map((obj: any, index: number) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{obj?.name}</td>
                              <td>{obj?.count}</td>
                              <td className="tableHeadData" ><CiCircleRemove 
                                onClick={() => handleRemoveSwabStick(obj.id, obj?.count)} 
                                fontSize={25} 
                                color="red"
                                style={{"cursor": "pointer"}}
                              /></td>
                            </tr>
                          );
                        })}
                    </tbody>
                    </table>
                    </div>
                  )}
                </div>
            </div>

              <div className="me-3" style={{ marginTop: "5px" }}>
                  <div className="mx-3 pe-2" style={{ height: "30vh", width: "100%" }}>
                      <CustomTable
                          tableHead={t("scheduleProduction.productionOperators")}
                          data={opTableData}
                          columns={opColumns}
                          isEditable={false}
                          totalElements={opTableData.length}
                          isActionVisible={false}
                          isViewVisible={false}
                          isSeachable={false}
                          addButton={false}
                          isToggleStatus={false}
                          isQrDownloadable={false}
                          showQrGenerateButton={false}
                          // isQrDownloadable={true}
                          // onEditClick={handleEditClick}
                          // onQrDownloadClick={handleQrDownload}
                          onActionClick={(val) => {
                              setSelectedOpSlNo(val);
                          }}
                      />
                  </div>
                  {/* <div>
          <Pagination
              page={opPage}
              totalPages={opTotalPages}
              handlePageChange={handleOpPageChange}
          />
          </div> */}
              </div>
              </div>

              <div className="bottomArea">
                  <button
                      onClick={() => handleQRFormClose()}
                      className="modalCancelBtn"
                  >
                      {t("buttons.cancel")}
                  </button>
                  <button
                      onClick={() => handleQrDownload()}
                      className="squareOrangeBtn3"
                  >
                      {t("buttons.generatePlateQR")}
                  </button>
              </div>
          </div>
      </Modal>

      {/*modal for generate QR version 2 */}
      <Modal
          className="top-right-modal"
          centered={false}
          show={showGenerateQrModalTest}
          size='lg'
      >
          {loader && <CustomLoader />}
          <div>
              <div className="modalHead">
                  <p className="modalHeadText ms-3 pt-3 p-2">
                      {modalName}
                  </p>
                  <div
                      style={{ cursor: "pointer" }}
                      onClick={() => handleQRFormClose()}
                      className="p-2 mx-3 my-2 "
                  >
                      <TfiClose fill="#FFFFFF" />
                  </div>
              </div>

              <div style={{"height": "80vh", "overflow": "scroll"}}>

              <div className="border m-1 text-start" >
                <h4 className="boldText4 ms-3 ps-3 mt-1">Plate Details</h4>
                <div className="selectWrap-new">
                    <div className="form-group my-1 mx-3 px-2">
                    <label htmlFor="">{t('plateInventory.plateType')}<span style={{ color: 'red' }}>*</span></label>
                        <br />
                        <select
                        id="plateType"
                        // value={addPlateData.plateType}
                        name="plateType"
                        onChange={handleQRFieldOnChange}
                        >
                        <option value="">{t('common.select')}</option>
                        {plateTypes.map((obj: any, index) => (
                            <option key={index} value={obj?.id}>
                            {obj?.plate_type}
                            </option>
                        ))}
                        </select>
                        {errors.plateType && <p className="errorText">{errors.plateType}</p>}
                    </div>
                    {/* <div className="form-group my-1 mx-3 px-2">
                        <label htmlFor="">{t('plateInventory.mediaType')}<span style={{ color: 'red' }}>*</span></label>
                        <br />
                        <select
                        id="mediaType"
                        // value={addPlateData.mediaType}
                        name="mediaType"
                        onChange={handleQRFieldOnChange}
                        >
                        <option value="">{t('common.select')}</option>
                        {mediaType.map((obj: any, index) => (
                            <option key={index} value={obj?.id}>
                            {obj?.name}
                            </option>
                        ))}
                        </select>
                        {errors.mediaType && <p className="errorText">{errors.mediaType}</p>}
                    </div> */}
                    <div className="form-group my-1 mx-2 px-2">
                        <label>
                            {t("scheduleProduction.batch")}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <br />
                        <select
                            id="batchId"
                            name="batchId"
                            onChange={handleQRFieldOnChange}
                        >
                            <option value="">{t("common.select")}</option>
                            {batchList.map((val) => (
                                <option key={val.id} value={val.id}>
                                    {val.name}
                                </option>
                            ))}
                        </select>
                        {errors.batchId && <p className="errorText">{errors.batchId}</p>}
                    </div>
                    <div className="form-group my-1 mx-2 px-2">
                        <label>
                            {t("scheduleProduction.lot")}
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <br />
                        <select id="lotId" name="lotId" value={qrFormData.lotId} onChange={handleQRFieldOnChange}>
                            <option value="">{t("common.select")}</option>
                              {lotList.map((val) => {
                                  const isDisabled = qrFormData?.lotIdWithRemainingPlates?.some(
                                      (item) => item.lot_id === val.id
                                  );

                                  return (
                                      <option key={val.id} value={val.id} disabled={isDisabled}>
                                          {val.name}
                                      </option>
                                  );
                              })}
                            {/* {lotList.map((val) => (
                                <option key={val.id} value={val.id}>
                                    {val.name}
                                </option>
                            ))} */}
                        </select>
                        {errors.lotId && <p className="errorText">{errors.lotId}</p>}
                    </div>
                    <div className="form-group my-1 ms-3">
                        <label className='mb-1'>
                            {t("scheduleProduction.totalPlatesNeeded")}
                        </label>
                        <br />
                        <input
                            id="plateCount"
                            name="plateCount"
                            type="text"
                            placeholder={t("scheduleProduction.totalPlatesNeeded")}
                            disabled={true}
                            style={{"width": "110px"}}
                            value={totalPlateCount}
                        />
                    </div>
                    <div className="form-group my-1 mx-2 px-2">
                      <label></label>
                      <br />
                      <button
                        onClick={() => handleAddLotWithRemainingPlateClick()}
                        className="squareOrangeBtn3"
                        style={{ opacity: totalPlatesRequires <= 0 ? 0.3 : 1 }}
                        disabled={totalPlatesRequires <= 0 ? true : false}
                      >
                        {t("buttons.add")}
                      </button>
                    </div>
                </div>
                {qrFormData?.lotIdWithRemainingPlates.length > 0 && (
                <div className="accordion ms-3 ps-3 my-2" id="accordionExample" style={{"width":"90%"}}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button boldText3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Selected Plate Details
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                          <table className="table table-bordered table-sm">
                            <thead >
                                <tr>
                                <th>SL No</th>
                                <th>Batch Name</th>
                                <th>Lot Code</th>
                                <th>Plates Count</th>
                                <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                {qrFormData?.lotIdWithRemainingPlates.map((obj: any, index: number) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{obj?.batchName}</td>
                                      <td>{obj?.lotCode}</td>
                                      <td>{obj?.plate_count}</td>
                                      <td className="tableHeadData" ><CiCircleRemove 
                                        onClick={() => handleRemovePlate(obj.lot_id, obj?.plate_count)} 
                                        fontSize={25} 
                                        color="red"
                                        style={{"cursor": "pointer"}}
                                      /></td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                      </div>
                    </div>
                  </div>
                </div>
                )}
              </div>

              <div className="justify-content-start d-flex" style={{"width" : "auto"}}>
                <div className='border m-1 text-start' style={{"width" : "50%"}} >
                  {opTableData[0]?.activity_type_id === "7" && (
                  <>
                    <h4 className="boldText4 ms-3 ps-3 mt-1">Saline Tube Details</h4>
                    <div className="selectWrap-new">
                      <div className="form-group my-1 mx-3 px-2">
                          <label>
                              {t("testTubeConfiguration.test_tube")}
                              <span style={{ color: "red" }}>*</span>
                          </label>
                          <br />
                          <select id="salineTube" name="salineTube" value={qrFormData.salineTube} onChange={handleQRFieldOnChange}>
                              <option value="">{t("common.select")}</option>
                                  {/* {salineTubeList.map((val) => (
                                      <option key={val.id} value={val.id}>
                                          {val.name}
                                      </option>
                                  ))} */}
                                  {salineTubeList.map((val) => {
                                    const isDisabled = qrFormData?.salineTubeWithRemainingPlates?.some(
                                        (item) => item.id === val.id
                                    );

                                    return (
                                        <option key={val.id} value={val.id} disabled={isDisabled}>
                                            {val.name}
                                        </option>
                                    );
                                  })}
                          </select>
                          {errors.salineTube && <p className="errorText">{errors.salineTube}</p>}
                      </div>
                      <div style={{"display":"none"}} className="form-group my-1 mx-2 px-2">
                          <label className='mb-1'>
                              {t("scheduleProduction.remainingTube")}
                          </label>
                          <br />
                          <input
                              type="text"
                              placeholder={t("scheduleProduction.remainingTube")}
                              style={{"width": "110px"}}
                              disabled={true}
                              value={totalSalineTubeCount}
                          />
                      </div>
                      <div className="form-group my-1">
                        <label></label>
                        <br />
                        <button
                          onClick={() => handleAddSalineTubeWithRemainingPlateClick()}
                          className="squareOrangeBtn3"
                          style={{ opacity: totalSalineRequires <= 0 ? 0.3 : 1 }}
                          disabled={totalSalineRequires <= 0 ? true : false}
                        >
                          {t("buttons.add")}
                        </button>
                      </div>
                    </div>
                    {qrFormData?.salineTubeWithRemainingPlates.length > 0 && (
                    <div className="accordion ms-3 ps-3 my-2" id="accordionExample" style={{"width":"90%"}}>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button className="accordion-button boldText3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                            Selected Saline Tube Details
                          </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                          <div className="accordion-body">
                              <table className="table table-bordered table-sm">
                                <thead >
                                    <tr>
                                    <th>SL No</th>
                                    <th>Saline Tube</th>
                                    <th>Expiry Date</th>
                                    {/* <th>Count</th> */}
                                    <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {qrFormData?.salineTubeWithRemainingPlates.map((obj: any, index: number) => {
                                      return (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>{obj?.name}</td>
                                          {/* <td>{obj?.count}</td> */}
                                          <td>{helperFunctions.formatDate(obj?.expiryDate)}</td>
                                          <td className="tableHeadData" ><CiCircleRemove 
                                            onClick={() => handleRemoveSalineTube(obj.id, obj?.count)} 
                                            fontSize={25} 
                                            color="red"
                                            style={{"cursor": "pointer"}}
                                          /></td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                  </>
                  )}
                </div>
                 <div className='border m-1 text-start' style={{"width" : "50%"}}>
                  {opTableData[0]?.activity_type_id === "7" && (
                  <>
                    <h4 className="boldText4 ms-3 ps-3 mt-1">Swab Stick Details</h4>
                    <div className="selectWrap-new">
                      <div className="form-group my-1 mx-3 px-2">
                      <label>
                          {t("swabStickInventry.swabStick")}
                          <span style={{ color: "red" }}>*</span>
                      </label>
                      <br />
                      <select id="swabStick" name="swabStick" value={qrFormData.swabStick} onChange={handleQRFieldOnChange}>
                          <option value="">{t("common.select")}</option>
                          {/* {swabStickList.map((val) => (
                              <option key={val.id} value={val.id}>
                                  {val.name}
                              </option>
                          ))} */}
                          {swabStickList.map((val) => {
                            const isDisabled = qrFormData?.swabWithRemainingPlates?.some(
                                (item) => item.id === val.id
                            );

                            return (
                                <option key={val.id} value={val.id} disabled={isDisabled}>
                                    {val.name}
                                </option>
                            );
                          })}
                      </select>
                      {errors.swabStick && <p className="errorText">{errors.swabStick}</p>}
                      </div>
                      <div style={{"display":"none"}} className="form-group my-1 mx-2 px-2">
                          <label className='mb-1'>
                              {t("scheduleProduction.remainingStick")}
                          </label>
                          <br />
                          <input
                              type="text"
                              placeholder={t("scheduleProduction.remainingStick")}
                              style={{"width": "110px"}}
                              disabled={true}
                              value={totalSwabCount}
                          />
                      </div>
                      <div className="form-group my-1">
                        <label></label>
                        <br />
                        <button
                          onClick={() => handleAddSwabStickWithRemainingPlateClick()}
                          className="squareOrangeBtn3"
                          style={{ opacity: totalSwabRequires <= 0 ? 0.3 : 1 }}
                          disabled={totalSwabRequires <= 0 ? true : false}
                        >
                          {t("buttons.add")}
                        </button>
                      </div>
                    </div>
                      {qrFormData?.swabWithRemainingPlates.length > 0 && (
                      <div className="accordion ms-3 ps-3 my-2" id="accordionExample" style={{"width":"90%"}}>
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button className="accordion-button boldText3" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                              Selected Swab Stick Details
                            </button>
                          </h2>
                          <div id="collapseThree" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                <table className="table table-bordered table-sm">
                                  <thead >
                                      <tr>
                                      <th>SL No</th>
                                      <th>Swab Stick</th>
                                      <th>Expiry Date</th>
                                      {/* <th>Count</th> */}
                                      <th></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {qrFormData?.swabWithRemainingPlates.map((obj: any, index: number) => {
                                        return (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{obj?.name}</td>
                                            <td>{helperFunctions.formatDate(obj?.expiryDate)}</td>
                                            {/* <td>{obj?.count}</td> */}
                                            <td className="tableHeadData" ><CiCircleRemove 
                                              onClick={() => handleRemoveSwabStick(obj.id, obj?.count)} 
                                              fontSize={25} 
                                              color="red"
                                              style={{"cursor": "pointer"}}
                                            /></td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      )}
                  </>
                  )}
                </div>
              </div>

              <div className="me-3" style={{ marginTop: "5px" }}>
                  <div className="mx-3 pe-2" style={{ height: "30vh", width: "100%" }}>
                      <CustomTable
                          tableHead={t("scheduleProduction.productionOperators")}
                          data={opTableData}
                          columns={opColumns}
                          isEditable={false}
                          totalElements={opTableData.length}
                          isActionVisible={false}
                          isViewVisible={false}
                          isSeachable={false}
                          addButton={false}
                          isToggleStatus={false}
                          isQrDownloadable={false}
                          showQrGenerateButton={false}
                          // isQrDownloadable={true}
                          // onEditClick={handleEditClick}
                          // onQrDownloadClick={handleQrDownload}
                          onActionClick={(val) => {
                              setSelectedOpSlNo(val);
                          }}
                      />
                  </div>
                  {/* <div>
          <Pagination
              page={opPage}
              totalPages={opTotalPages}
              handlePageChange={handleOpPageChange}
          />
          </div> */}
              </div>
              </div>

              <div className="bottomArea">
                  <button
                      onClick={() => handleQRFormClose()}
                      className="modalCancelBtn"
                  >
                      {t("buttons.cancel")}
                  </button>
                  <button
                      onClick={() => handleQrDownload()}
                      className="squareOrangeBtn3"
                  >
                      {t("buttons.generatePlateQR")}
                  </button>
              </div>
          </div>
      </Modal>

      {/* Alert modal for Add/edit Operator schedule */}
      <AlertModal
        show={showAddAreaAlert}
        onHide={() => setShowAddAreaAlert(false)}
        title={t("common.alert")}
        message={modalName}
        onConfirm={handleFormSubmit}
      />

      {/* Alert modal for Add/edit Operator assign */}
      <AlertModal
        show={assigSubmitAlert}
        onHide={() => setAssigSubmitAlert(false)}
        title={t("common.alert")}
        message={modalName}
        onConfirm={handleAssignFormSubmit}
      />

      {/* Alert modal for reassign */}
      <AlertModal
        show={reAssigSubmitAlert}
        onHide={() => setReAssigSubmitAlert(false)}
        title={t("common.alert")}
        message={modalName}
        onConfirm={handleReAssignFormSubmit}
      />
    </div>
  )
}

export default ScheduleOperatorV2